import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ECR } from '../models/ecr';
import { ECRService } from '../service/ecr.service';
import $ from "jquery";
import { ActivatedRoute, Router } from '@angular/router';
import { DropzoneComponent, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { SharedService } from '../service/shared.service';
import { AuthService } from '../service/auth.service';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import { CrudService } from '../service/crud.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MultiSelectComponent } from 'ng-multiselect-dropdown';

declare var Jodit: any;

@Component({
  selector: 'app-ecr',
  templateUrl: './ecr.component.html',
  styleUrls: ['./ecr.component.css']
})

export class EcrComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('Favauto', { static: false }) Favauto;
  @ViewChild('ccDropdown', { static: false }) ccDropdown: MultiSelectComponent;
  @ViewChild('ccWrap', { static: false }) ccWrap: ElementRef;
  @ViewChild('ecrEditor', { static: false }) ecrEditor: ElementRef<HTMLTextAreaElement>;
  htmlContent: any;
  EcrModel: ECR = new ECR();
  DisableSubmitButton: boolean = false;
  keyword = 'name';
  Defaultkeyword = 'name';
  MinDate: any;
  today: any;
  EmailSelect: any;
  employeesList: any;
  itemList = [];
  itemListAutoCom = [];
  itemListDefaultAutoCom = [];
  selectedItems = [];
  selectedFavList = [];
  selectedDefaultList = [];
  settings = {
    idField: 'id',
    textField: 'item_text',
    enableCheckAll: false,
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 5,
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
    closeDropDownOnSelection: false,
    singleSelection: false,
    limitSelection: -1,
    clearSearchFilter: true,
    maxHeight: 220,
    showSelectedItemsAtTop: false,
    defaultOpen: false,
    selectAllText: ' ',
    searchPlaceholderText: 'Search email...',
    noDataAvailablePlaceholderText: 'Type to search employees'
  };
  EmployeeDetails: any;
  MaxDate: any;
  EmployeeData: any;
  ECRFiles: any;
  token: any = "";

  showEmailPanel = false;
  emailPanelTab: 'fav' | 'default' = 'fav';
  showCCBox: boolean = false;
  ccShowNoResults = false;
  private ccFilterDebounceTimer: any = null;
  private ccFilterSearchSub: any = null;
  private ccSearchQuery: string = '';
  private ccKeepOpen = false;
  private ccPointerDownTarget: HTMLElement | null = null;
  CompanyName: string = '';
  reportingHeadId: any = '';
  /** Deep-link date from My Day (?date=YYYY-MM-DD). */
  pendingEcrDate = '';
  showPendingEcrHint = false;
  private readonly ecrDraftStoragePrefix = 'ecr-draft:';
  private readonly ecrDraftMaxAgeMs = 48 * 60 * 60 * 1000;
  private ecrDraftSaveTimer: any = null;
  private ecrDraftPromptShown = false;
  private discardEcrDraft = false;

  showDriver: boolean = false;
  band: any = sessionStorage.getItem('Band');
  @ViewChild('dropzoneECR', { static: false }) componentRef: DropzoneComponent; // Second
  mydropzoneECR: any;
  dropzoneConfig: DropzoneConfigInterface;
  private suppressAttachmentDelete = false;
  private loadAttachmentsRetry = 0;
  private submittedEcrDates = new Set<string>();
  private submittedDatesMonthKey = '';
  // @ViewChild('auto') auto;

  private jodit: any = null;
  private lastJoditImageFileName = '';
  private embeddedImageUploadChain: Promise<void> = Promise.resolve();
  /** Filenames uploaded for editor inline images (not dropzone attachments). */
  private inlineEcrImageFileNames = new Set<string>();
  private readonly joditConfig: any = {
    readonly: false,
    height: 300,
    minHeight: 220,
    placeholder: 'Enter text here...',
    language: 'en',
    toolbarAdaptive: false,
    addNewLine: false,
    showTooltip: true,
    useNativeTooltip: true,
    buttons: [
      'undo', 'redo', '|', 'bold', 'italic', 'underline',
      '|', 'font', 'brush', 'fontsize', 'paragraph', 'align', 'ul', 'ol', 'indent', 'outdent', 'lineHeight',
      'hr', '|', 'image', 'table',
    ],
    controls: {
      paragraph: {
        list: {
          p: 'Normal',
          h1: 'Heading 1',
          h2: 'Heading 2',
          h3: 'Heading 3',
          h4: 'Heading 4',
          h5: 'Heading 5',
          h6: 'Heading 6'
        }
      }
    },
    removeButtons: [],
    defaultActionOnPaste: 'insert_as_html',
    defaultActionOnPasteFromWord: 'insert_as_html',
    processPasteHTML: true,
    processPasteFromWord: true,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    pastePlain: false,
    uploader: {
      insertImageAsBase64URI: false,
      url: '',
      method: 'POST',
      format: 'json',
      headers: {},
      imagesExtensions: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'],
      filesVariableName: (index: number) => 'files[' + index + ']',
      processFileName: (_key: string, _file: File, name: string) => {
        this.lastJoditImageFileName = name;
        return [_key, _file, name];
      },
      prepareData: (formData: FormData) => {
        formData.append('TMCNo', this.EcrModel.TMCNo || sessionStorage.getItem('userId') || '');
        formData.append('Ecrdate', this.EcrModel.EcrDate || '');
        return formData;
      },
      isSuccess: (response: any) => !!(response && (
        response.Status === true || response.status === true || response.success === true ||
        response.Status === 'true' || response.status === 'true' || response.success === 'true' ||
        response.Data || response.data
      )),
      getMessage: (response: any) => (response && (response.Message || response.message)) || 'Image upload failed',
      process: (response: any) => this.processEcrImageUploadResponse(response),
      error: (error: Error) => console.error('ECR image upload failed', error)
    },
    cleanHTML: {
      removeEmptyElements: false,
      fillEmptyParagraph: false,
      denyTags: 'script,style,iframe,object,embed,form,base,meta,link'
    },
    events: {
      beforePaste: (_event: ClipboardEvent, html: string) => this.preparePastedEcrHtml(html)
    }
  };
  constructor(private _ecrService: ECRService, private sharedService: SharedService, public datepipe: DatePipe, private _crudService: CrudService,
    private authService: AuthService, private activatedRoute: ActivatedRoute, private _router: Router, private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef
  ) {
    this.dropzoneConfig = {
      url: this._crudService.siteUrl + 'ecr/PostECRFiles',
      method: 'POST',
      maxFilesize: 500,
      timeout: 360000,
      headers: this._crudService.getApiKeyHeaderMap(),
      acceptedFiles: '.jpeg,.jpg,.png,.gif,.mp4,.pdf,.xls,.xlsx,.txt,.doc,.docx,.csv,.ppt,.pptx,application/vnd.ms-excel',
      addRemoveLinks: true,
      dictRemoveFile: 'Delete',
    };

    this.showCCBox = true;
    if (window.localStorage.getItem('FullNameTHR') == undefined || window.localStorage.getItem('FullNameTHR') == "undefined" || window.localStorage.getItem('FullNameTHR') == "" || window.localStorage.getItem('FullNameTHR') == null || window.localStorage.getItem('FullNameTHR') == "null") {

    }
    this.EcrModel.TMCNo = sessionStorage.getItem('userId');
    this.EcrModel.EmployeeName = sessionStorage.getItem('FullName');
    this.EcrModel.FromEmail = sessionStorage.getItem('UserEmail');
    this.CompanyName = sessionStorage.getItem('companyId');
    // console.log('sessionStorage.getItem("companyId ")>>', this.CompanyName)
    this.EcrModel.ToEmail = sessionStorage.getItem('ReportingManagerEmail');
    this.reportingHeadId = sessionStorage.getItem('ReportingManagerName');

    // console.log('this.EcrModel.ToEmail>>', this.EcrModel.ToEmail)
    // console.log('sessionStorage.getItem("ReportingManagerEmail")>>', sessionStorage.getItem('userId'), sessionStorage.getItem('UserEmail'), sessionStorage.getItem('FullName'), sessionStorage.getItem('CompanyName'), sessionStorage.getItem('ReportingManagerEmail'), sessionStorage.getItem('ReportingManagerName'))
  }


  GetEmail() {
    this.EcrModel.OtherEmail += this.EmailSelect + ",";
  }
  // RemoveFile(item: any) {
  //   
  //   alert('File removed');
  // }

  onUploadError(item: any) {
    console.error('ECR file upload failed', item);
    const message = (item && item[1] && item[1].message) ? item[1].message : 'File upload failed. Please try again.';
    alert(message);
  }


  DeleteECRFile(FileName) {
    if (!FileName || !this.EcrModel.TMCNo || !this.EcrModel.EcrDate) {
      return;
    }
    this._ecrService.DeleteECRFiles(this.EcrModel.TMCNo, this.EcrModel.EcrDate, FileName).subscribe(
      data => {
        if (data.Status) {
          //alert('File Deleted');
        }

      },
      error => {
        console.log(error);
        console.error();
      }
    );

  }

  DeleteECRFileDateWise() {
    this._ecrService.DeleteECRFilesDateWise(this.EcrModel.TMCNo, this.EcrModel.EcrDate).subscribe(
      data => {

      },
      error => {
        console.log(error);
        console.error();
      }
    );

  }

  private getEcrDropzone(): any {
    if (!this.componentRef || !this.componentRef.directiveRef) {
      return null;
    }
    return this.componentRef.directiveRef.dropzone();
  }

  private clearDropzonePreview(deleteFromServer: boolean): void {
    const dropzone = this.getEcrDropzone();
    if (!dropzone) {
      return;
    }
    this.suppressAttachmentDelete = !deleteFromServer;
    try {
      dropzone.removeAllFiles(true);
    } finally {
      this.suppressAttachmentDelete = false;
    }
  }

  private normalizeEcrAttachmentList(data: any): Array<{ name: string; size: number }> {
    const raw = data && data.Data !== undefined ? data.Data : data;
    if (!raw || typeof raw === 'string') {
      return [];
    }
    const list = Array.isArray(raw) ? raw : [];
    const files: Array<{ name: string; size: number }> = [];
    list.forEach((item: any) => {
      const name = typeof item === 'string' ? item : (item && (item.name || item.Name || item.fileName || item.FileName));
      if (!name) {
        return;
      }
      const sizeValue = typeof item === 'object' ? (item.size || item.Size || 0) : 0;
      files.push({ name: String(name), size: Number(sizeValue) || 0 });
    });
    return files;
  }

  /** Inline editor images use PostECRFiles but must not appear as dropzone attachments. */
  private isEcrInlineImageFileName(fileName: string): boolean {
    const raw = String(fileName || '').trim();
    if (!raw) {
      return false;
    }
    let base = raw.split('/').pop() || raw;
    try {
      base = decodeURIComponent(base);
    } catch (_e) { /* keep raw base */ }
    const lower = base.toLowerCase();
    if (this.inlineEcrImageFileNames.has(base) || this.inlineEcrImageFileNames.has(lower)) {
      return true;
    }
    // Legacy renamed paste uploads from earlier builds.
    return lower.indexOf('ecr-inline-') === 0 || lower.indexOf('ecr-paste-') === 0;
  }

  private getInlineEcrFileStorageKey(): string {
    const tmc = this.EcrModel.TMCNo || sessionStorage.getItem('userId') || '';
    const date = this.toEcrDateKey(this.EcrModel.EcrDate);
    if (!tmc || !date) {
      return '';
    }
    return 'ecr-inline-files:' + tmc + ':' + date;
  }

  private rememberInlineEcrFileName(fileName: string): void {
    const raw = String(fileName || '').trim();
    if (!raw) {
      return;
    }
    let base = raw.split('/').pop() || raw;
    try {
      base = decodeURIComponent(base);
    } catch (_e) { /* keep */ }
    this.inlineEcrImageFileNames.add(base);
    this.persistInlineEcrFileNames();
  }

  private persistInlineEcrFileNames(): void {
    const key = this.getInlineEcrFileStorageKey();
    if (!key) {
      return;
    }
    try {
      sessionStorage.setItem(key, JSON.stringify(Array.from(this.inlineEcrImageFileNames)));
    } catch (_e) { /* ignore quota */ }
  }

  private loadInlineEcrFileNamesForCurrentDate(): void {
    this.inlineEcrImageFileNames = new Set<string>();
    const key = this.getInlineEcrFileStorageKey();
    if (!key) {
      return;
    }
    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) {
        return;
      }
      const list = JSON.parse(raw);
      if (Array.isArray(list)) {
        list.forEach((name: any) => {
          if (name) {
            this.inlineEcrImageFileNames.add(String(name));
          }
        });
      }
    } catch (_e) { /* ignore */ }
  }

  private clearInlineEcrFileNamesForCurrentDate(): void {
    const key = this.getInlineEcrFileStorageKey();
    this.inlineEcrImageFileNames = new Set<string>();
    if (key) {
      try {
        sessionStorage.removeItem(key);
      } catch (_e) { /* ignore */ }
    }
  }

  private getUserEcrAttachments(files: Array<{ name: string; size: number }>): Array<{ name: string; size: number }> {
    return (files || []).filter(file => !this.isEcrInlineImageFileName(file.name));
  }

  private showExistingEcrAttachments(files: Array<{ name: string; size: number }>): void {
    const dropzone = this.getEcrDropzone();
    if (!dropzone) {
      return;
    }

    this.clearDropzonePreview(false);
    files.forEach(file => {
      const mockFile: any = {
        name: file.name,
        size: file.size,
        accepted: true,
        status: 'success',
        kind: 'existing'
      };
      dropzone.emit('addedfile', mockFile);
      dropzone.emit('complete', mockFile);
      if (!dropzone.files || dropzone.files.indexOf(mockFile) === -1) {
        dropzone.files.push(mockFile);
      }
      const ext = file.name.split('.').pop().toLowerCase();
      if (['jpg', 'jpeg', 'png', 'gif', 'webp'].indexOf(ext) !== -1) {
        dropzone.emit('thumbnail', mockFile, this.getEcrUploadedFileUrl(file.name));
      }
    });
    this.cdr.detectChanges();
  }

  FileNames: string = "Choose file";
  fileToUpload: FileList = null;
  //   handleFileInput(files: FileList) {
  //  if(this.EcrModel.EcrDate==null || this.EcrModel.EcrDate==undefined){
  //    alert('Please select ECR Date');
  //    return;
  //  }
  //     this.fileToUpload = files; 
  //     let FileformData: FormData = new FormData();
  //     if (this.fileToUpload != null) {
  //       for (let i = 0; i < this.fileToUpload.length; i++) {

  //         this.FileNames = this.fileToUpload.item(i).name;
  //         FileformData.append(this.fileToUpload.item(i).name, this.fileToUpload.item(i));
  //       }

  //       FileformData.append("TMCNo", this.EcrModel.TMCNo);
  //       FileformData.append("Ecrdate", this.EcrModel.EcrDate);


  //       this._ecrService.SaveECRFiles(FileformData).subscribe(
  //         data => {        
  //           console.log(data);
  //           if(data.Status){
  //           }
  //         },
  //         error => {
  //           if (error.statusText) {
  //             console.log(error);

  //           }
  //           console.log(error);
  //           console.error();
  //         }
  //       );
  //     }
  //     else {
  //       this.FileNames = "Choose file";
  //     }

  //   }
  private toEcrDateKey(value: any): string {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(value.trim());
      if (iso) {
        return iso[1] + '-' + iso[2] + '-' + iso[3];
      }
      const dmy = /^(\d{2})[\/-](\d{2})[\/-](\d{4})/.exec(value.trim());
      if (dmy) {
        return dmy[3] + '-' + dmy[2] + '-' + dmy[1];
      }
    }
    const parsed = new Date(value);
    if (isNaN(parsed.getTime())) {
      return '';
    }
    const year = parsed.getFullYear();
    const month = ('0' + (parsed.getMonth() + 1)).slice(-2);
    const day = ('0' + parsed.getDate()).slice(-2);
    return year + '-' + month + '-' + day;
  }

  private rememberSubmittedEcrDate(dateValue: any): void {
    const key = this.toEcrDateKey(dateValue);
    if (key) {
      this.submittedEcrDates.add(key);
    }
  }

  private isSelectedEcrDateAlreadySubmitted(): boolean {
    const key = this.toEcrDateKey(this.EcrModel.EcrDate);
    return !!key && this.submittedEcrDates.has(key);
  }

  private clearSubmittedDayAttachments(): void {
    this.FileNames = 'Choose file';
    this.clearDropzonePreview(false);
  }

  private loadSubmittedDatesThenAttachments(): void {
    if (!this.EcrModel.TMCNo || !this.EcrModel.EcrDate) {
      return;
    }
    const dateKey = this.toEcrDateKey(this.EcrModel.EcrDate);
    if (!dateKey) {
      return;
    }
    const parts = dateKey.split('-');
    const year = Number(parts[0]);
    const month = Number(parts[1]);
    const monthKey = year + '-' + month;

    const applyAttachments = () => {
      if (this.toEcrDateKey(this.EcrModel.EcrDate) !== dateKey) {
        return;
      }
      if (this.isSelectedEcrDateAlreadySubmitted()) {
        this.clearSubmittedDayAttachments();
        return;
      }
      this.GetAllFilesByEcrDate();
    };

    if (this.submittedDatesMonthKey === monthKey) {
      applyAttachments();
      return;
    }

    this._ecrService.GetECRByTMCAndMonthCalender(this.EcrModel.TMCNo, month, year).subscribe(
      data => {
        this.submittedDatesMonthKey = monthKey;
        if (data && data.Status && Array.isArray(data.Data)) {
          data.Data.forEach((item: any) => {
            this.rememberSubmittedEcrDate(item.ECRDate || item.EcrDate);
          });
        }
        applyAttachments();
      },
      error => {
        console.error(error);
        applyAttachments();
      }
    );
  }

  GetAllFilesByEcrDate() {
    if (!this.EcrModel.TMCNo || !this.EcrModel.EcrDate) {
      return;
    }
    this.loadInlineEcrFileNamesForCurrentDate();
    if (this.isSelectedEcrDateAlreadySubmitted()) {
      this.clearSubmittedDayAttachments();
      return;
    }
    if (!this.getEcrDropzone()) {
      if (this.loadAttachmentsRetry < 8) {
        this.loadAttachmentsRetry++;
        setTimeout(() => this.GetAllFilesByEcrDate(), 250);
      }
      return;
    }
    this.loadAttachmentsRetry = 0;
    const requestedDate = this.toEcrDateKey(this.EcrModel.EcrDate);
    this._ecrService.GetAllFilesByEcrDate(this.EcrModel.TMCNo, this.EcrModel.EcrDate).subscribe(
      data => {
        if (this.toEcrDateKey(this.EcrModel.EcrDate) !== requestedDate || this.isSelectedEcrDateAlreadySubmitted()) {
          this.clearSubmittedDayAttachments();
          return;
        }
        const files = this.getUserEcrAttachments(this.normalizeEcrAttachmentList(data));
        this.FileNames = files.map(file => file.name).join(', ') || 'Choose file';
        this.showExistingEcrAttachments(files);
      },
      error => {
        console.log(error);
        console.error();
        this.clearDropzonePreview(false);
      }
    );

  }

  GetEcrDate() {
    if (this.EcrModel.EcrDate > this.MaxDate) {
      alert('you cannot select future date');
      this.EcrModel.EcrDate = this.MaxDate;
    }
    this.loadInlineEcrFileNamesForCurrentDate();
    this.loadSubmittedDatesThenAttachments();
    // Images pasted before a date was chosen can now be uploaded.
    this.enqueueEmbeddedImageUpload();
  }

  UpdateCSS() {

    for (let i = 1; i <= this.selectedFavList.length; i++) {
      var divItem = (<HTMLDivElement>document.querySelector(".multiselect-dropdown li.multiselect-item-checkbox:nth-child(" + i + ") div"));
      divItem.setAttribute("style", "color:#337ab7 !important;");
      //divItem.innerHTML="<span style='color:red !important;'> Welcome</span>";
    }

  }
  InitFunction() {

    //debugger;
    this.GetServerDate().then(
      r => {
        if (r.Status) {
          this.EcrModel.SubmittedDate = r.Data;
          var date = this.stringToDate(r.Data, "dd/MM/yyyy", "/");
          const offset = date.getTimezoneOffset()
          date = new Date(date.getTime() - (offset * 60 * 1000));

          //this.MaxDate = date.toISOString().split('T')[0];

          var MaxECRDate = date;
          MaxECRDate.setDate(MaxECRDate.getDate());
          this.MaxDate = MaxECRDate.toISOString().split('T')[0];

          //  this.EcrModel.EcrDate =r.Data;
          var LastECRDate = date;
          //  console.log(date);
          this.EcrModel.EcrDate = date.toISOString().split('T')[0];
          //  this.EcrModel.EcrDate=this.stringToDate(this.EcrModel.EcrDate, "dd/MM/yyyy", "/");
          //    
          LastECRDate.setDate(LastECRDate.getDate() - 2);
          this.MinDate = LastECRDate.toISOString().split('T')[0];

        }

      }).then(s => {
        this.applyPendingEcrDate();
        this.GetEmailSettings();
        this.loadSubmittedDatesThenAttachments();
        // this.getEmployee(this.EcrModel.TMCNo);


      }).catch(e => {
        alert(JSON.stringify(e));
      });
    this.GetEmployees().then(
      r => {
        if (r.Status) {

          this.EmployeeData = r.Data;
          this.employeesList = r.Data;
          this.syncCcItemList();

          // 👉 autocomplete list (already correct tha, same rakha)
          this.itemListAutoCom = [];
          this.employeesList.forEach(element => {
            if (element != "") {
              this.itemListAutoCom.push({
                id: element.CompaneyEmail,
                name: element.CompaneyEmail.toString().trim()
              });
            }
          });

          // 👉 default autocomplete list
          this.itemListDefaultAutoCom = [];
          this.employeesList.forEach(element => {
            if (element != "") {
              this.itemListDefaultAutoCom.push({
                id: element.CompaneyEmail,
                name: element.CompaneyEmail.toString().trim()
              });
            }
          });

        }
      }
    ).catch(e => {
      console.error(e);
    });

  }

  private clearModalArtifacts(): void {
    document.body.classList.remove('modal-open', 'ecr-email-drawer-open');
    $('.modal-backdrop').remove();
    this.showEmailPanel = false;
  }

  ngOnInit() {
    this.clearModalArtifacts();
    this.EcrModel.ToEmail = sessionStorage.getItem('ReportingManagerEmail');
    //this.EcrModel = new ECR();
    if (sessionStorage.getItem('LoginFlag') == "2") {
      this.EcrModel.TMCNo = sessionStorage.getItem("userIdTHR");
    } else {
      this.EcrModel.TMCNo = sessionStorage.getItem("userId");
    }
    this.token = this.activatedRoute.snapshot.queryParamMap.get('t');
    this.pendingEcrDate = this.readPendingEcrDate();
    if (this.token) {
      this.loginFromSSO(this.token);
    } else {
      this.InitFunction();
    }
  }

  private readPendingEcrDate(): string {
    const raw = this.activatedRoute.snapshot.queryParamMap.get('date') || '';
    return this.normalizeEcrDateParam(raw);
  }

  private normalizeEcrDateParam(raw: string): string {
    const value = (raw || '').trim();
    if (!value) {
      return '';
    }
    const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
    if (iso) {
      return `${iso[1]}-${iso[2]}-${iso[3]}`;
    }
    const dmy = /^(\d{2})[/-](\d{2})[/-](\d{4})/.exec(value);
    if (dmy) {
      return `${dmy[3]}-${dmy[2]}-${dmy[1]}`;
    }
    return '';
  }

  private applyPendingEcrDate(): void {
    const pending = this.pendingEcrDate;
    if (!pending) {
      this.showPendingEcrHint = false;
      return;
    }

    // A pending ECR may be older than the normal selectable window.
    // Preserve the task's exact date when opening from My Day.
    this.EcrModel.EcrDate = pending;
    this.showPendingEcrHint = true;
    this.cdr.detectChanges();
  }

  loginFromSSO(token: any) {
    this.token = this.activatedRoute.snapshot.queryParamMap.get('t') || token;
    if (this.sharedService.checkProperty(this.token)) {
      return;
    }
    this.authService.markSessionActive();
    const formdata = new FormData();
    formdata.append('token', this.token);

    this.authService.userLoginSSO(formdata).subscribe(
      udata => {
        if (udata.Status) {
          const userResult = udata.Data;
          const roles = userResult.UserRole || [];

          sessionStorage.setItem('userId', userResult.TMC);
          localStorage.setItem('userId', userResult.TMC);
          sessionStorage.setItem('FullName', userResult.Full_Name);
          sessionStorage.setItem('ReportingHeadId', userResult.Reporting_Head_ID);
          sessionStorage.setItem('ReportingManagerName', userResult.Reporting_Head_Name);
          sessionStorage.setItem('ReportingManagerEmail', userResult.Reporting_Head_Email);
          sessionStorage.setItem('UserEmail', userResult.Company_E_Mail);
          sessionStorage.setItem('UserDesignation', userResult.Designation);
          sessionStorage.setItem('UserDepartment', userResult.Department);
          sessionStorage.setItem('UserSBU', userResult.EmployeeSBU);
          sessionStorage.setItem('UserSUBBU', userResult.SUBBU_Code);
          sessionStorage.setItem('UserSBUCode', userResult.SBUCode);
          sessionStorage.setItem('UserBranch', userResult.Branch);
          sessionStorage.setItem('UserLocation', userResult.Location_Code);
          sessionStorage.setItem('IsHrAdmin', userResult.HR_Admin);
          sessionStorage.setItem('DOJ', userResult.Date_of_Joining);
          sessionStorage.setItem('Band', userResult.Employee_Band);
          sessionStorage.setItem('IsReEmployee', userResult.IsReEmployee);
          sessionStorage.setItem('phoneNo', userResult.Mobile_Phone_No);
          sessionStorage.setItem('Birth_Date', userResult.Birth_Date);
          sessionStorage.setItem('CompanyName', userResult.CompanyName || 'TCPL');
          sessionStorage.setItem('companyId', userResult.companyId);
          const isBuhrFlagEcr = userResult.ISBUHR === 1 || userResult.ISBUHR === '1' || userResult.ISBUHR === true;
          sessionStorage.setItem('ISBUHR', isBuhrFlagEcr ? '1' : '0');

          if (roles.filter(x => x.ACCESS_ROLE == 'HRPROFILE').length > 0) {
            sessionStorage.setItem('UserHRRole', roles.filter(x => x.ACCESS_ROLE == this.sharedService.UserRoleHR)[0].ACCESS_ROLE);
          } else {
            sessionStorage.setItem('UserHRRole', '');
          }
          if (roles.filter(x => x.ACCESS_ROLE == 'ACCOUNTS').length > 0) {
            sessionStorage.setItem('UserAccountsRole', roles.filter(x => x.ACCESS_ROLE == this.sharedService.UserRoleAccounts)[0].ACCESS_ROLE);
          } else {
            sessionStorage.setItem('UserAccountsRole', '');
          }
          if (roles.filter(x => x.ACCESS_ROLE == 'BUHEAD').length > 0) {
            sessionStorage.setItem('UserRoleBUHead', roles.filter(x => x.ACCESS_ROLE == this.sharedService.UserRoleBUHead)[0].ACCESS_ROLE);
          } else {
            sessionStorage.setItem('UserRoleBUHead', '');
          }
          if (roles.filter(x => x.ACCESS_ROLE == 'TRAVELDESK').length > 0) {
            sessionStorage.setItem('UserTravelDesk', roles.filter(x => x.ACCESS_ROLE == this.sharedService.UserTravelDesk)[0].ACCESS_ROLE);
          } else {
            sessionStorage.setItem('UserTravelDesk', '');
          }
          if (roles.filter(x => x.ACCESS_ROLE == 'FINANCE').length > 0) {
            sessionStorage.setItem('UserFinanceRole', roles.filter(x => x.ACCESS_ROLE == this.sharedService.UserRoleFinance)[0].ACCESS_ROLE);
          } else {
            sessionStorage.setItem('UserFinanceRole', '');
          }
          if (roles.filter(x => x.ACCESS_ROLE == 'KOCKPIT').length > 0) {
            sessionStorage.setItem('UserKockpitRole', roles.filter(x => x.ACCESS_ROLE == this.sharedService.UserKockpitRole)[0].ACCESS_ROLE);
          } else {
            sessionStorage.setItem('UserKockpitRole', '');
          }
          if (roles.filter(x => x.ACCESS_ROLE == 'CFO').length > 0) {
            sessionStorage.setItem('UserCFORole', roles.filter(x => x.ACCESS_ROLE == this.sharedService.UserCFORole)[0].ACCESS_ROLE);
          } else {
            sessionStorage.setItem('UserCFORole', '');
          }

          sessionStorage.setItem('Reportees', userResult.Reportees);
          sessionStorage.setItem('LoginFlag', '1');
          userResult.LoginFlag = 1;
          this.sharedService.setItem('userdata', udata.Data);
          this.sharedService.setUserData(userResult);
          this.sharedService.UserId = sessionStorage.getItem('userId');
          this.authService.markSessionActive();
          this.EcrModel.TMCNo = sessionStorage.getItem('userId');
          this.EcrModel.EmployeeName = sessionStorage.getItem('FullName');
          this.EcrModel.FromEmail = sessionStorage.getItem('UserEmail');
          this.EcrModel.ToEmail = sessionStorage.getItem('ReportingManagerEmail');
          this.CompanyName = sessionStorage.getItem('companyId');
          this.reportingHeadId = sessionStorage.getItem('ReportingManagerName');

          const pendingDate = this.pendingEcrDate || this.readPendingEcrDate();
          this.pendingEcrDate = pendingDate;
          // Remove the SSO token without recreating the component and losing the pending date.
          window.history.replaceState({}, document.title, window.location.pathname);
          this.InitFunction();
        } else {
          alert(udata.Message);
          this._router.navigate(['/']);
        }
      },
      error => {
        console.log(error);
        alert('SSO login failed. Please try again or sign in manually.');
        this._router.navigate(['/']);
      }
    );
  }

  private formatCcListItem(element: any): { id: string; item_text: string } {
    const email = element.CompaneyEmail ? element.CompaneyEmail.toString().trim() : '';
    return { id: email, item_text: email };
  }

  private buildDefaultCcItemList(): any[] {
    const tempList = [];

    if (this.EcrModel.OtherEmail && this.EcrModel.OtherEmail.length > 0) {
      this.EcrModel.OtherEmail.forEach(element => {
        if (element && element.id) {
          tempList.push({
            id: element.id,
            item_text: element.item_text || element.id
          });
        }
      });
    }

    if (this.selectedFavList && this.selectedFavList.length > 0) {
      this.selectedFavList.forEach(element => {
        if (element && element.id) {
          tempList.push({
            id: element.id,
            item_text: element.id
          });
        }
      });
    }

    if (this.employeesList) {
      this.employeesList.forEach(element => {
        if (element != "") {
          tempList.push(this.formatCcListItem(element));
        }
      });
    }

    return this.findUnique(tempList, d => d.id);
  }

  private syncCcItemList(): void {
    this.itemList = this.buildDefaultCcItemList();
    this.cdr.detectChanges();
  }

  private mergeSelectedWithCcResults(results: any[]): any[] {
    const tempList = [];

    if (this.EcrModel.OtherEmail && this.EcrModel.OtherEmail.length > 0) {
      this.EcrModel.OtherEmail.forEach(element => {
        if (element && element.id) {
          tempList.push({
            id: element.id,
            item_text: element.item_text || element.id
          });
        }
      });
    }

    results.forEach(item => {
      if (item && item.id) {
        tempList.push(item);
      }
    });

    return this.findUnique(tempList, d => d.id);
  }

  private applyCcSearchResults(query: string, results: any[]): void {
    if (results.length === 0) {
      this.ccShowNoResults = true;
      this.itemList = this.mergeSelectedWithCcResults([]);
    } else {
      this.ccShowNoResults = false;
      this.itemList = this.mergeSelectedWithCcResults(results);
    }
    this.updateCcDropdownPlaceholder(true, results.length === 0);
    this.cdr.detectChanges();
  }

  private updateCcDropdownPlaceholder(activeSearch: boolean, noResults: boolean): void {
    this.settings.noDataAvailablePlaceholderText = (activeSearch && noResults)
      ? 'No result found'
      : 'Type to search employees';
  }

  private runCcRemoteSearch(query: string): void {
    if (this.ccFilterSearchSub) {
      this.ccFilterSearchSub.unsubscribe();
      this.ccFilterSearchSub = null;
    }

    this.ccFilterSearchSub = this._ecrService.GetEmployeesListBySearch(query).subscribe(
      r => {
        this.ccFilterSearchSub = null;
        if (this.ccSearchQuery !== query) {
          return;
        }

        const tempList = [];
        const rows = r && r.Data && Array.isArray(r.Data) ? r.Data : [];

        if (r && r.Status && rows.length > 0) {
          rows.forEach(element => {
            if (element != "") {
              tempList.push(this.formatCcListItem(element));
            }
          });
        }

        this.applyCcSearchResults(query, tempList);
      },
      error => {
        this.ccFilterSearchSub = null;
        if (this.ccSearchQuery === query) {
          this.applyCcSearchResults(query, []);
        }
        console.error(error);
      }
    );
  }

  public onFilterChange(item: any) {
    if (this.ccFilterDebounceTimer) {
      clearTimeout(this.ccFilterDebounceTimer);
      this.ccFilterDebounceTimer = null;
    }

    const query = item ? String(item).trim() : '';
    this.ccSearchQuery = query;

    if (!query) {
      this.ccShowNoResults = false;
      this.syncCcItemList();
      this.updateCcDropdownPlaceholder(false, false);
      this.cdr.detectChanges();
      return;
    }

    if (query.length < 2) {
      this.ccShowNoResults = false;
      return;
    }

    this.ccShowNoResults = false;
    this.ccFilterDebounceTimer = setTimeout(() => {
      this.ccFilterDebounceTimer = null;
      this.runCcRemoteSearch(query);
    }, 400);
  }

  ngAfterViewInit(): void {
    if (!this.ecrEditor || this.jodit) {
      return;
    }

    const textarea = this.ecrEditor.nativeElement;
    this.joditConfig.uploader.url = this._crudService.siteUrl + 'ecr/PostECRFiles';
    this.joditConfig.uploader.headers = this._crudService.getApiKeyHeaderMap();
    // Force Jodit paragraph dropdown to show only Normal + Heading 1-6
    if (Jodit.defaultOptions &&
      Jodit.defaultOptions.controls &&
      Jodit.defaultOptions.controls.paragraph) {
      Jodit.defaultOptions.controls.paragraph.list = {
        p: 'Normal',
        h1: 'Heading 1',
        h2: 'Heading 2',
        h3: 'Heading 3',
        h4: 'Heading 4',
        h5: 'Heading 5',
        h6: 'Heading 6'
      };
    }

    this.jodit = Jodit.make(textarea, this.joditConfig);
    this.jodit.value = this.sanitizeEcrHtml(this.EcrModel.ECRDetails || '');
    this.syncEcrEditorValue();
    this.labelJoditToolbarButtons();

    // Keep Jodit's native selection/formatting pipeline intact.
    // Do not manually save/restore selections or rewrite font spans here:
    // Jodit already preserves the editor selection while toolbar popups are open.
    this.jodit.events.on('change', () => this.syncEcrEditorValue());
    this.jodit.events.on('afterSetMode', () => this.clearEmptyEcrEditor());
    this.jodit.events.on('focus', () => this.clearEmptyEcrEditor());
    // Google Docs / Word paste often leaves data:/blob:/googleusercontent images.
    // Re-host them on the ECR file API so sanitize + email keep a public https src.
    this.jodit.events.on('afterPaste', () => {
      setTimeout(() => {
        this.scrubLiveEditorImagePlaceholders();
        this.enqueueEmbeddedImageUpload();
      }, 0);
    });

    // If a heading is applied AFTER an explicit font size, the selected text can still
    // contain a child <span style="font-size:...">. That inline size wins over the
    // heading's own size, making H1/H2/etc. look as if they did not work.
    // Clear only the pre-existing inline size created before the heading command.
    // A font size chosen AFTER the heading remains allowed and works normally.
    this.jodit.events.on('afterCommand', (command: string, _showUI: boolean, value: any) => {
      this.normalizeJoditHeadingAfterCommand(command, value);
    });
  }

  private normalizeJoditHeadingAfterCommand(command: string, value: any): void {
    if (!this.jodit || !this.jodit.editor) {
      return;
    }

    const commandName = String(command || '').toLowerCase();
    const headingTag = String(value || '')
      .toLowerCase()
      .replace(/[<>]/g, '')
      .trim();

    // Jodit normally uses formatBlock for the Paragraph/Heading control.
    // Keep paragraph as a compatibility fallback for older Jodit builds.
    if ((commandName !== 'formatblock' && commandName !== 'paragraph') || !/^h[1-6]$/.test(headingTag)) {
      return;
    }

    const editor = this.jodit.editor as HTMLElement;
    const selection = window.getSelection();
    const headings = Array.from(editor.querySelectorAll(headingTag)) as HTMLElement[];

    if (!headings.length) {
      return;
    }

    let affectedHeadings: HTMLElement[] = [];

    if (selection && selection.rangeCount) {
      const range = selection.getRangeAt(0);
      affectedHeadings = headings.filter((heading: HTMLElement) => {
        try {
          return range.intersectsNode(heading);
        } catch (_e) {
          return heading.contains(range.commonAncestorContainer);
        }
      });

      // For a collapsed selection after formatBlock, intersectsNode can be browser-dependent.
      // Resolve the heading from the caret/anchor as a fallback.
      if (!affectedHeadings.length && selection.anchorNode) {
        const anchorElement = selection.anchorNode.nodeType === Node.TEXT_NODE
          ? selection.anchorNode.parentElement
          : selection.anchorNode as HTMLElement;
        const closestHeading = anchorElement && anchorElement.closest
          ? anchorElement.closest(headingTag) as HTMLElement
          : null;
        if (closestHeading && editor.contains(closestHeading)) {
          affectedHeadings = [closestHeading];
        }
      }
    }

    // In the unlikely case selection is no longer exposed after the command, do nothing
    // rather than altering unrelated headings in the document.
    if (!affectedHeadings.length) {
      return;
    }

    affectedHeadings.forEach((heading: HTMLElement) => {
      // Remove only size formatting that existed before the heading was chosen.
      // Keep font-family, color, bold, italic, etc. untouched.
      if (heading.style.fontSize) {
        heading.style.removeProperty('font-size');
      }

      Array.from(heading.querySelectorAll('[style]')).forEach((node: Element) => {
        const element = node as HTMLElement;
        if (element.style.fontSize) {
          element.style.removeProperty('font-size');
          if (!element.getAttribute('style') || !element.getAttribute('style').trim()) {
            element.removeAttribute('style');
          }
        }
      });

      Array.from(heading.querySelectorAll('font[size]')).forEach((node: Element) => {
        node.removeAttribute('size');
      });
    });

    this.jodit.synchronizeValues();
    this.syncEcrEditorValue();
  }

  private syncEcrEditorValue(): void {
    if (!this.jodit) {
      return;
    }

    // IMPORTANT: Never assign a sanitized/normalized value back to Jodit here.
    // This method runs on every editor `change` event, including font/font-size commands.
    // Reassigning `this.jodit.value` rebuilds the editable DOM and destroys Jodit's
    // current Range/selection, so the next toolbar command has no selected text to format.
    const rawValue = this.jodit.value || '';
    const sanitizedValue = this.sanitizeEcrHtml(rawValue);
    const normalizedValue = this.isMeaningfulEcrHtml(sanitizedValue) ? sanitizedValue : '';

    // Keep the application model sanitized, but leave Jodit's live DOM untouched.
    this.EcrModel.ECRDetails = normalizedValue;

    // The original textarea is only a backing field after Jodit is created.
    // Updating its value directly does not replace/re-render the Jodit editable DOM.
    if (this.ecrEditor && this.ecrEditor.nativeElement.value !== normalizedValue) {
      this.ecrEditor.nativeElement.value = normalizedValue;
    }

    this.scheduleEcrDraftSave();
  }

  private clearEmptyEcrEditor(): void {
    if (!this.jodit || this.isMeaningfulEcrHtml(this.jodit.value || '')) {
      return;
    }
    if (this.jodit.value) {
      this.jodit.value = '';
    }
    this.EcrModel.ECRDetails = '';
    if (this.ecrEditor) {
      this.ecrEditor.nativeElement.value = '';
    }
  }

  private resetEcrFormAfterSubmit(): void {
    const tmcNo = sessionStorage.getItem('userId') || this.EcrModel.TMCNo;

    this.discardEcrDraft = true;
    if (this.ecrDraftSaveTimer) {
      clearTimeout(this.ecrDraftSaveTimer);
      this.ecrDraftSaveTimer = null;
    }
    this.clearEcrDraft();

    this.EcrModel = new ECR();
    this.EcrModel.TMCNo = tmcNo;
    this.EcrModel.EmployeeName = sessionStorage.getItem('FullName');
    this.EcrModel.FromEmail = sessionStorage.getItem('UserEmail');
    this.EcrModel.ToEmail = sessionStorage.getItem('ReportingManagerEmail');
    this.CompanyName = sessionStorage.getItem('companyId');
    this.reportingHeadId = sessionStorage.getItem('ReportingManagerName');
    this.pendingEcrDate = '';
    this.showPendingEcrHint = false;
    this.FileNames = 'Choose file';
    this.DisableSubmitButton = false;

    if (this.jodit) {
      this.jodit.value = '';
      if (this.jodit.history && typeof this.jodit.history.clear === 'function') {
        this.jodit.history.clear();
      }
    }
    this.EcrModel.ECRDetails = '';
    if (this.ecrEditor && this.ecrEditor.nativeElement) {
      this.ecrEditor.nativeElement.value = '';
    }
    this.clearEmptyEcrEditor();

    if (this.ecrDraftSaveTimer) {
      clearTimeout(this.ecrDraftSaveTimer);
      this.ecrDraftSaveTimer = null;
    }
    this.clearEcrDraft();
    this.discardEcrDraft = false;
    this.ecrDraftPromptShown = true;

    this.clearDropzonePreview(false);

    this.InitFunction();
    this.cdr.detectChanges();
  }

  private getEcrDraftStorageKey(): string {
    const tmcNo = sessionStorage.getItem('userId') || this.EcrModel.TMCNo || 'anonymous';
    return this.ecrDraftStoragePrefix + encodeURIComponent(tmcNo);
  }

  private scheduleEcrDraftSave(): void {
    if (this.discardEcrDraft) {
      return;
    }
    if (this.ecrDraftSaveTimer) {
      clearTimeout(this.ecrDraftSaveTimer);
    }
    this.ecrDraftSaveTimer = setTimeout(() => {
      this.ecrDraftSaveTimer = null;
      this.saveEcrDraft();
    }, 500);
  }

  private saveEcrDraft(): void {
    if (this.discardEcrDraft || !this.EcrModel || !this.hasMeaningfulEcrContent()) {
      if (!this.hasMeaningfulEcrContent() && (!this.EcrModel.OtherEmail || !this.EcrModel.OtherEmail.length)) {
        this.clearEcrDraft();
      }
      return;
    }

    const draft = {
      savedAt: new Date().getTime(),
      EcrDate: this.EcrModel.EcrDate || '',
      ECRDetails: this.EcrModel.ECRDetails || '',
      OtherEmail: (this.EcrModel.OtherEmail || []).map(item => ({
        id: item && item.id ? item.id : '',
        item_text: item && (item.item_text || item.id) ? (item.item_text || item.id) : ''
      })).filter(item => item.id)
    };

    try {
      localStorage.setItem(this.getEcrDraftStorageKey(), JSON.stringify(draft));
    } catch (e) {
      console.warn('Unable to save ECR draft locally', e);
    }
  }

  private readEcrDraft(): any | null {
    try {
      const raw = localStorage.getItem(this.getEcrDraftStorageKey());
      if (!raw) {
        return null;
      }
      const draft = JSON.parse(raw);
      if (!draft || !draft.savedAt || new Date().getTime() - draft.savedAt > this.ecrDraftMaxAgeMs) {
        this.clearEcrDraft();
        return null;
      }
      return draft;
    } catch (e) {
      this.clearEcrDraft();
      return null;
    }
  }

  private clearEcrDraft(): void {
    try {
      localStorage.removeItem(this.getEcrDraftStorageKey());
    } catch (e) {
      // Ignore storage restrictions; the form must continue working.
    }
  }

  private promptForSavedEcrDraft(): void {
    if (this.ecrDraftPromptShown || this.discardEcrDraft) {
      return;
    }

    const draft = this.readEcrDraft();
    if (!draft || !draft.ECRDetails) {
      return;
    }

    this.ecrDraftPromptShown = true;
    Swal.fire({
      title: 'Previous ECR found',
      text: 'Do you want to keep your unfinished ECR?',
      showCancelButton: true,
      confirmButtonText: 'Keep draft',
      cancelButtonText: 'Start new',
      confirmButtonColor: '#159aab',
      cancelButtonColor: '#64748b',
      allowOutsideClick: false
    }).then(result => {
      if (result.isConfirmed) {
        this.EcrModel.EcrDate = draft.EcrDate || this.EcrModel.EcrDate;
        this.EcrModel.ECRDetails = draft.ECRDetails || '';
        this.EcrModel.OtherEmail = Array.isArray(draft.OtherEmail) ? draft.OtherEmail : [];
        if (this.jodit) {
          this.jodit.value = this.EcrModel.ECRDetails;
        }
        this.syncCcItemList();
        this.cdr.detectChanges();
      } else {
        this.discardEcrDraft = true;
        this.clearEcrDraft();
      }
    });
  }

  @HostListener('window:beforeunload')
  onEcrBeforeUnload(): void {
    if (this.jodit) {
      this.syncEcrEditorValue();
    }
    this.saveEcrDraft();
  }

  private processEcrImageUploadResponse(response: any): any {
    const rawData = response && (response.Data || response.data) ? (response.Data || response.data) : response;
    const data = Array.isArray(rawData) ? rawData[0] : rawData;
    const returnedValue = typeof data === 'string'
      ? data
      : data && (data.Url || data.url || data.Path || data.path || data.FileName || data.fileName || data.Name || data.name || data.File);
    const directUrl = /^https?:\/\//i.test(String(returnedValue || '')) ? String(returnedValue) : '';
    const fileName = directUrl
      ? directUrl.substring(directUrl.lastIndexOf('/') + 1)
      : (returnedValue || this.lastJoditImageFileName);
    const baseUrl = directUrl
      ? directUrl.substring(0, directUrl.lastIndexOf('/') + 1)
      : this.getEcrUploadedFileUrl('').replace(/\/$/, '') + '/';
    if (fileName) {
      this.rememberInlineEcrFileName(String(fileName));
    }
    return {
      files: fileName ? [fileName] : [],
      isImages: [true],
      baseurl: fileName ? baseUrl : '',
      newfilename: fileName || ''
    };
  }

  private getEcrUploadedFileUrl(fileName: string): string {
    const date = this.datepipe.transform(this.EcrModel.EcrDate, 'dd-MM-yyyy');
    const tmcNo = this.EcrModel.TMCNo || sessionStorage.getItem('userId') || '';
    const encodedName = String(fileName).split('/').map(part => encodeURIComponent(part)).join('/');
    return this._crudService.DownLoadURL + encodeURIComponent(tmcNo) + '/' + date + '/' + encodedName;
  }

  /** Queue so rapid paste / submit do not race parallel uploads. */
  private enqueueEmbeddedImageUpload(): Promise<void> {
    this.embeddedImageUploadChain = this.embeddedImageUploadChain
      .then(() => this.uploadEmbeddedEcrImages())
      .catch(error => {
        console.error('ECR embedded image upload failed', error);
      });
    return this.embeddedImageUploadChain;
  }

  /**
   * Pasted Google Docs / Word images often use data:, blob:, or googleusercontent URLs.
   * Jodit shows them in the editor, but sanitizeEcrHtml strips non-public srcs on submit.
   * Upload those images to PostECRFiles and swap in a stable https URL for mail.
   */
  private async uploadEmbeddedEcrImages(): Promise<void> {
    if (!this.jodit || !this.jodit.editor) {
      return;
    }
    if (!this.EcrModel.EcrDate) {
      return;
    }

    const images = Array.from(this.jodit.editor.querySelectorAll('img')) as HTMLImageElement[];
    if (!images.length) {
      return;
    }

    let changed = false;
    for (let i = 0; i < images.length; i++) {
      const img = images[i];
      const src = (img.getAttribute('src') || img.src || '').trim();
      if (!this.needsEcrImageRehost(src)) {
        continue;
      }
      try {
        const file = await this.ecrImageElementToFile(img, i);
        const uploadedUrl = await this.uploadEcrInlineImageFile(file);
        if (uploadedUrl) {
          img.setAttribute('src', uploadedUrl);
          img.src = uploadedUrl;
          changed = true;
        }
      } catch (error) {
        console.error('Could not re-host pasted ECR image', error);
        // Keep bytes in the HTML as data: so sanitize/submit do not drop the <img>.
        // Prefer upload above; this is only a last-resort for temporary blob: views.
        try {
          if (/^blob:/i.test(src)) {
            const blob = await (await fetch(src)).blob();
            const dataUri = await this.blobToDataUri(blob);
            img.setAttribute('src', dataUri);
            img.src = dataUri;
            changed = true;
          }
        } catch (fallbackError) {
          console.error('Could not convert blob image to data URI', fallbackError);
        }
      }
    }

    if (changed) {
      this.jodit.synchronizeValues();
      this.syncEcrEditorValue();
    }
    this.scrubLiveEditorImagePlaceholders();
  }

  /** Remove Docs image placeholder "?" / U+FFFC left in the live editor DOM. */
  private scrubLiveEditorImagePlaceholders(): void {
    if (!this.jodit || !this.jodit.editor) {
      return;
    }
    const editor = this.jodit.editor as HTMLElement;
    let changed = false;

    const walker = document.createTreeWalker(editor, NodeFilter.SHOW_TEXT);
    const textNodes: Text[] = [];
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode as Text);
    }
    textNodes.forEach(node => {
      const original = node.nodeValue || '';
      const cleaned = original
        .replace(/\uFFFC/g, '')
        .replace(/\uFFFD/g, '')
        .replace(/[\u200B\u200C\u200D\uFEFF]/g, '');
      if (cleaned !== original) {
        node.nodeValue = cleaned;
        changed = true;
      }
    });

    Array.from(editor.querySelectorAll('p,div,span,h1,h2,h3,h4,h5,h6,li')).forEach(el => {
      if (el.querySelector('img,table,ul,ol,hr,iframe')) {
        return;
      }
      const text = (el.textContent || '').replace(/\u00a0/g, ' ').trim();
      if (text === '?') {
        el.remove();
        changed = true;
      }
    });

    if (changed) {
      this.jodit.synchronizeValues();
      this.syncEcrEditorValue();
    }
  }

  private needsEcrImageRehost(src: string): boolean {
    const value = (src || '').trim();
    if (!value) {
      return false;
    }
    if (this.isHostedEcrImageUrl(value)) {
      return false;
    }
    if (/^data:image\//i.test(value) || /^blob:/i.test(value)) {
      return true;
    }
    // Google Docs clipboard images are signed/auth URLs that mail clients cannot load.
    if (/googleusercontent\.com/i.test(value) || /docs\.google\.com/i.test(value)) {
      return true;
    }
    // Protocol-relative Google image hosts
    if (/^\/\/[^/]*googleusercontent\.com/i.test(value)) {
      return true;
    }
    return false;
  }

  private isHostedEcrImageUrl(src: string): boolean {
    const value = (src || '').trim();
    const downloadBase = (this._crudService.DownLoadURL || '').replace(/\/?$/, '/');
    return !!downloadBase && value.indexOf(downloadBase) === 0;
  }

  private async ecrImageElementToFile(img: HTMLImageElement, index: number): Promise<File> {
    const src = (img.getAttribute('src') || img.src || '').trim();
    let blob: Blob;

    if (/^data:image\//i.test(src)) {
      blob = this.dataUriToBlob(src);
    } else {
      try {
        const response = await fetch(src, { credentials: 'omit', mode: 'cors' });
        if (!response.ok) {
          throw new Error('Image fetch failed: ' + response.status);
        }
        blob = await response.blob();
      } catch (fetchError) {
        // Google Docs hosts often block CORS; use the already-rendered image pixels.
        blob = await this.ecrImageElementToBlobViaCanvas(img);
      }
    }

    if (!blob || !blob.size) {
      throw new Error('Empty image blob');
    }

    const mime = (blob.type || 'image/png').split(';')[0];
    const ext = this.extensionFromImageMime(mime);
    const name = this.resolveEcrInlineImageFileName(img, ext, index);
    return new File([blob], name, { type: mime });
  }

  /** Prefer the image's real file name; fall back to "attachment". */
  private resolveEcrInlineImageFileName(img: HTMLImageElement, ext: string, index: number): string {
    const candidates = [
      img.getAttribute('data-filename'),
      img.getAttribute('data-file-name'),
      img.getAttribute('title'),
      img.getAttribute('alt'),
      this.fileNameFromUrl(img.getAttribute('src') || img.src || ''),
      this.lastJoditImageFileName
    ];

    let base = '';
    for (let i = 0; i < candidates.length; i++) {
      const cleaned = this.sanitizeEcrUploadBaseName(candidates[i]);
      if (cleaned) {
        base = cleaned;
        break;
      }
    }
    if (!base) {
      base = 'attachment';
    }

    // Strip an existing extension so we can apply the real mime extension.
    base = base.replace(/\.(jpe?g|png|gif|webp|bmp|svg)$/i, '');
    if (!base) {
      base = 'attachment';
    }

    let name = base + '.' + ext;
    if (index > 0 && base === 'attachment') {
      name = 'attachment-' + (index + 1) + '.' + ext;
    } else if (this.inlineEcrImageFileNames.has(name)) {
      name = base + '-' + (index + 1) + '.' + ext;
    }
    return name;
  }

  private fileNameFromUrl(src: string): string {
    const value = String(src || '').trim();
    if (!value || /^data:/i.test(value) || /^blob:/i.test(value)) {
      return '';
    }
    try {
      const path = value.split('?')[0].split('#')[0];
      let segment = path.substring(path.lastIndexOf('/') + 1);
      segment = decodeURIComponent(segment);
      if (!segment || segment.length > 180) {
        return '';
      }
      return segment;
    } catch (_e) {
      return '';
    }
  }

  private sanitizeEcrUploadBaseName(raw: any): string {
    let value = String(raw || '').trim();
    if (!value) {
      return '';
    }
    // Ignore placeholder alts like "?" from Google Docs.
    if (value === '?' || value === '￼' || /^image$/i.test(value)) {
      return '';
    }
    value = value.replace(/[<>:"/\\|?*\u0000-\u001f]/g, ' ').replace(/\s+/g, ' ').trim();
    if (!value || value.length > 120) {
      return '';
    }
    return value;
  }

  private ecrImageElementToBlobViaCanvas(img: HTMLImageElement): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const draw = () => {
        try {
          const width = img.naturalWidth || img.width;
          const height = img.naturalHeight || img.height;
          if (!width || !height) {
            reject(new Error('Image has no dimensions'));
            return;
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            reject(new Error('Canvas unavailable'));
            return;
          }
          ctx.drawImage(img, 0, 0);
          canvas.toBlob((result) => {
            if (!result) {
              reject(new Error('Canvas export failed (likely CORS-tainted image)'));
              return;
            }
            resolve(result);
          }, 'image/png');
        } catch (error) {
          reject(error);
        }
      };

      if (img.complete && (img.naturalWidth || img.width)) {
        draw();
      } else {
        img.onload = () => draw();
        img.onerror = () => reject(new Error('Image failed to load'));
      }
    });
  }

  private editorHasUnhostedImages(): boolean {
    if (!this.jodit || !this.jodit.editor) {
      return /<img\b[^>]*\bsrc\s*=\s*["'](?:blob:|https?:\/\/[^"']*googleusercontent\.com)/i
        .test(this.EcrModel.ECRDetails || '');
    }
    const images = Array.from(this.jodit.editor.querySelectorAll('img')) as HTMLImageElement[];
    return images.some(img => {
      const src = (img.getAttribute('src') || img.src || '').trim();
      if (!src || this.isHostedEcrImageUrl(src) || /^data:image\//i.test(src)) {
        return false;
      }
      return /^blob:/i.test(src)
        || /googleusercontent\.com/i.test(src)
        || /docs\.google\.com/i.test(src);
    });
  }

  private blobToDataUri(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ''));
      reader.onerror = () => reject(reader.error || new Error('FileReader failed'));
      reader.readAsDataURL(blob);
    });
  }

  private dataUriToBlob(dataUri: string): Blob {
    const parts = String(dataUri || '').split(',');
    if (parts.length < 2) {
      throw new Error('Invalid data URI');
    }
    const header = parts[0];
    const mimeMatch = /data:([^;]+)/i.exec(header);
    const mime = (mimeMatch && mimeMatch[1]) || 'image/png';
    const isBase64 = /;base64/i.test(header);
    const binary = isBase64 ? atob(parts[1]) : decodeURIComponent(parts[1]);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type: mime });
  }

  private extensionFromImageMime(mime: string): string {
    const map: { [key: string]: string } = {
      'image/jpeg': 'jpg',
      'image/jpg': 'jpg',
      'image/png': 'png',
      'image/gif': 'gif',
      'image/webp': 'webp',
      'image/svg+xml': 'svg',
      'image/bmp': 'bmp'
    };
    return map[(mime || '').toLowerCase()] || 'png';
  }

  private uploadEcrInlineImageFile(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('files[0]', file, file.name);
    formData.append('TMCNo', this.EcrModel.TMCNo || sessionStorage.getItem('userId') || '');
    formData.append('Ecrdate', this.EcrModel.EcrDate || '');
    this.lastJoditImageFileName = file.name;

    return this._ecrService.SaveECRFiles(formData).toPromise().then((response: any) => {
      const ok = response && (
        response.Status === true || response.status === true || response.success === true ||
        response.Status === 'true' || response.status === 'true' || response.success === 'true' ||
        response.Data || response.data
      );
      if (!ok) {
        throw new Error((response && (response.Message || response.message)) || 'Image upload failed');
      }
      const processed = this.processEcrImageUploadResponse(response);
      const fileName = processed && processed.files && processed.files[0] ? processed.files[0] : '';
      if (!fileName) {
        throw new Error('Image upload returned no file name');
      }
      const storedName = /^https?:\/\//i.test(fileName)
        ? (fileName.split('?')[0].split('/').pop() || file.name)
        : fileName;
      this.rememberInlineEcrFileName(storedName || file.name);
      if (/^https?:\/\//i.test(fileName)) {
        return fileName;
      }
      return this.getEcrUploadedFileUrl(fileName);
    });
  }

  /**
   * Inline paste images are stored via PostECRFiles (same folder as attachments).
   * Remove tracked/legacy inline files that are NOT referenced in the current
   * editor HTML so a later text-only submit does not email/show them as attachments.
   */
  private async cleanupUnreferencedInlineEcrImages(): Promise<void> {
    if (!this.EcrModel.TMCNo || !this.EcrModel.EcrDate) {
      return;
    }
    this.loadInlineEcrFileNamesForCurrentDate();

    let response: any;
    try {
      response = await this._ecrService.GetAllFilesByEcrDate(this.EcrModel.TMCNo, this.EcrModel.EcrDate).toPromise();
    } catch (error) {
      console.error('Could not list ECR files for inline cleanup', error);
      return;
    }

    const inlineFiles = this.normalizeEcrAttachmentList(response)
      .filter(file => this.isEcrInlineImageFileName(file.name));
    if (!inlineFiles.length) {
      return;
    }

    const html = this.getCurrentEcrHtmlForInlineRefs();
    const deletions: Promise<any>[] = [];
    const kept: string[] = [];
    inlineFiles.forEach(file => {
      if (!this.isInlineFileReferencedInHtml(file.name, html)) {
        deletions.push(this.deleteEcrFileQuietly(file.name));
      } else {
        kept.push(file.name);
      }
    });
    if (deletions.length) {
      await Promise.all(deletions);
    }
    this.inlineEcrImageFileNames = new Set<string>();
    kept.forEach(name => this.rememberInlineEcrFileName(name));
    if (!kept.length) {
      this.clearInlineEcrFileNamesForCurrentDate();
    } else {
      this.persistInlineEcrFileNames();
    }
  }

  private getCurrentEcrHtmlForInlineRefs(): string {
    const parts: string[] = [];
    if (this.jodit) {
      if (this.jodit.value) {
        parts.push(String(this.jodit.value));
      }
      if (this.jodit.editor && this.jodit.editor.innerHTML) {
        parts.push(String(this.jodit.editor.innerHTML));
      }
    }
    if (this.EcrModel.ECRDetails) {
      parts.push(String(this.EcrModel.ECRDetails));
    }
    return parts.join('\n');
  }

  private isInlineFileReferencedInHtml(fileName: string, html: string): boolean {
    const name = String(fileName || '').trim();
    if (!name || !html) {
      return false;
    }
    if (html.indexOf(name) !== -1) {
      return true;
    }
    try {
      const encoded = encodeURIComponent(name);
      if (encoded && html.indexOf(encoded) !== -1) {
        return true;
      }
    } catch (_e) { /* ignore */ }
    // Compare against last path segment of any img src in the HTML
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return Array.from(doc.querySelectorAll('img')).some(img => {
        const src = (img.getAttribute('src') || '').trim();
        if (!src) {
          return false;
        }
        let segment = src.split('?')[0].split('/').pop() || '';
        try {
          segment = decodeURIComponent(segment);
        } catch (_e2) { /* keep */ }
        return segment.toLowerCase() === name.toLowerCase();
      });
    } catch (_e3) {
      return false;
    }
  }

  private deleteEcrFileQuietly(fileName: string): Promise<void> {
    if (!fileName || !this.EcrModel.TMCNo || !this.EcrModel.EcrDate) {
      return Promise.resolve();
    }
    return this._ecrService.DeleteECRFiles(this.EcrModel.TMCNo, this.EcrModel.EcrDate, fileName)
      .toPromise()
      .then(() => undefined)
      .catch(error => {
        console.error('Could not delete unused inline ECR image', fileName, error);
      });
  }

  private labelJoditToolbarButtons(): void {
    if (!this.jodit || !this.jodit.container) {
      return;
    }

    const labels = {
      font: 'Font',
      fontsize: 'Size',
      paragraph: 'Heading',
      brush: 'Color',
      align: 'Align',
      lineHeight: 'Height'
    };
    Object.keys(labels).forEach(name => {
      const button = this.jodit.container.querySelector(
        '.jodit-toolbar-button_' + name + ', [data-ref="' + name + '"]'
      ) as HTMLElement;
      if (button) {
        button.setAttribute('title', labels[name]);
        button.setAttribute('aria-label', labels[name]);
      }
    });
  }

  /**
   * Jodit shows pasted data: images as blob: in the editable DOM.
   * Restore the real src from editor.value before email HTML is built.
   */
  private restoreDataUriImagesFromJoditValue(clone: HTMLElement): void {
    if (!this.jodit || !clone) {
      return;
    }
    const valueHtml = this.jodit.value || '';
    if (!valueHtml || valueHtml.indexOf('<img') === -1) {
      return;
    }
    const valueDoc = new DOMParser().parseFromString(valueHtml, 'text/html');
    const valueImages = Array.from(valueDoc.querySelectorAll('img'));
    const cloneImages = Array.from(clone.querySelectorAll('img'));
    const total = Math.min(valueImages.length, cloneImages.length);
    for (let i = 0; i < total; i++) {
      const valueSrc = (valueImages[i].getAttribute('src') || '').trim();
      const cloneSrc = (cloneImages[i].getAttribute('src') || '').trim();
      if (/^blob:/i.test(cloneSrc) && (/^data:image\//i.test(valueSrc) || /^https?:\/\//i.test(valueSrc))) {
        cloneImages[i].setAttribute('src', valueSrc);
      }
    }
  }

  /**
   * Builds the HTML that is actually sent to the API/email.
   *
   * Excel/Word/Jodit can render formatting through CSS classes such as xl65/xl67.
   * Those class definitions are not reliable once the HTML reaches an email client.
   * This method reads the CURRENT rendered styles from the live Jodit editor and
   * writes only the styles that actually change appearance as inline CSS.
   *
   * Dumping every computed property on every node inflates the HTML past Outlook's
   * ~102KB clip limit ("View full message"). Structure, tables, and formatting
   * are preserved; default/inherited editor chrome is not repeated.
   */
  private getEcrHtmlForEmail(): string {
    if (!this.jodit || !this.jodit.editor) {
      return this.sanitizeEcrHtml(this.EcrModel.ECRDetails || '');
    }

    const editor = this.jodit.editor as HTMLElement;
    const clone = editor.cloneNode(true) as HTMLElement;

    // Jodit's imageProcessor shows data: images as blob: in the editable DOM.
    // Mail/sanitize must use the real data: (or already-uploaded https) src.
    this.restoreDataUriImagesFromJoditValue(clone);

    // Jodit can temporarily insert selection markers in the editable DOM.
    // They must never be stored in ECRDetails or sent by email.
    const tempNodes = clone.querySelectorAll(
      '[data-jodit-temp], [data-jodit-selection_marker], [id^="jodit-selection_marker_"]'
    );

    Array.from(tempNodes).forEach((node: Element) => {
      if (node.parentNode) {
        node.parentNode.removeChild(node);
      }
    });

    const sourceElements = editor.querySelectorAll('*');
    const cloneElements = clone.querySelectorAll('*');

    const typographyProperties = [
      'color',
      'font-family',
      'font-size',
      'font-weight',
      'font-style'
    ];

    const inheritedProperties = [
      'text-decoration',
      'text-align',
      'line-height',
      'white-space'
    ];

    const skipTypographyTags = /^(BR|HR|COL|COLGROUP|THEAD|TBODY|TFOOT|SCRIPT|STYLE|IMG|META|LINK)$/;

    const nonInheritedProperties = [
      'background-color',
      'vertical-align',
      'border-collapse',

      'border-top-width',
      'border-top-style',
      'border-top-color',
      'border-right-width',
      'border-right-style',
      'border-right-color',
      'border-bottom-width',
      'border-bottom-style',
      'border-bottom-color',
      'border-left-width',
      'border-left-style',
      'border-left-color',

      'padding-top',
      'padding-right',
      'padding-bottom',
      'padding-left',
      'margin-top',
      'margin-right',
      'margin-bottom',
      'margin-left'
    ];

    /*
     * IMPORTANT:
     * sourceElements and cloneElements have the same DOM order immediately after
     * cloneNode(true). We intentionally apply styles first and remove Jodit temp
     * markers separately so the actual user content remains aligned.
     *
     * To avoid any index mismatch caused by removed temp nodes, map by traversing
     * the original source and clone before writing the final HTML.
     */
    const sourceList: HTMLElement[] = [];
    const cloneList: HTMLElement[] = [];

    Array.from(sourceElements).forEach((node: Element) => {
      const sourceElement = node as HTMLElement;
      if (
        sourceElement.hasAttribute('data-jodit-temp') ||
        sourceElement.hasAttribute('data-jodit-selection_marker') ||
        (sourceElement.id && sourceElement.id.indexOf('jodit-selection_marker_') === 0)
      ) {
        return;
      }
      sourceList.push(sourceElement);
    });

    Array.from(cloneElements).forEach((node: Element) => {
      const cloneElement = node as HTMLElement;
      if (
        cloneElement.hasAttribute('data-jodit-temp') ||
        cloneElement.hasAttribute('data-jodit-selection_marker') ||
        (cloneElement.id && cloneElement.id.indexOf('jodit-selection_marker_') === 0)
      ) {
        return;
      }
      cloneList.push(cloneElement);
    });

    const defaultStyleCache: { [tag: string]: CSSStyleDeclaration } = {};
    const probe = this.createEcrStyleProbe();

    try {
      const getDefaultStyle = (tagName: string): CSSStyleDeclaration => {
        const tag = (tagName || 'span').toLowerCase();
        if (!defaultStyleCache[tag]) {
          defaultStyleCache[tag] = window.getComputedStyle(this.createEcrStyleProbeSample(probe, tag));
        }
        return defaultStyleCache[tag];
      };

      const editorComputed = window.getComputedStyle(editor);
      const total = Math.min(sourceList.length, cloneList.length);

      for (let i = 0; i < total; i++) {
        const sourceElement = sourceList[i];
        const cloneElement = cloneList[i];

        if (!sourceElement || !cloneElement) {
          continue;
        }

        const computed = window.getComputedStyle(sourceElement);
        const parentComputed = sourceElement.parentElement
          ? window.getComputedStyle(sourceElement.parentElement)
          : editorComputed;
        const defaultComputed = getDefaultStyle(sourceElement.tagName);
        const styles: string[] = [];

        // Word/Excel often put font/size/color on a parent or CSS class.
        // Email clients do not inherit those the way the editor does, so stamp
        // typography on each content node even when it matches the parent.
        if (!skipTypographyTags.test(sourceElement.tagName)) {
          typographyProperties.forEach((property: string) => {
            const formatted = this.formatEmailCssProperty(property, computed, sourceElement);
            if (formatted) {
              styles.push(property + ':' + formatted);
            }
          });
        }

        inheritedProperties.forEach((property: string) => {
          const value = computed.getPropertyValue(property);
          const parentValue = parentComputed.getPropertyValue(property);
          if (!this.cssValuesEqual(value, parentValue)) {
            styles.push(property + ':' + value.trim());
          }
        });

        nonInheritedProperties.forEach((property: string) => {
          const value = computed.getPropertyValue(property);
          const defaultValue = defaultComputed.getPropertyValue(property);
          if (!this.cssValuesEqual(value, defaultValue)) {
            styles.push(property + ':' + value.trim());
          }
        });

        // Preserve explicit HTML dimensions from pasted Excel tables.
        const width = sourceElement.getAttribute('width');
        const height = sourceElement.getAttribute('height');

        if (width) {
          cloneElement.setAttribute('width', width);
        }

        if (height) {
          cloneElement.setAttribute('height', height);
        }

        if (/^(OL|UL|LI)$/.test(sourceElement.tagName)) {
          const start = sourceElement.getAttribute('start');
          const type = sourceElement.getAttribute('type');
          const value = sourceElement.getAttribute('value');
          if (start) {
            cloneElement.setAttribute('start', start);
          }
          if (type) {
            cloneElement.setAttribute('type', type);
          }
          if (value) {
            cloneElement.setAttribute('value', value);
          }
          const listType = computed.getPropertyValue('list-style-type');
          if (listType && listType !== 'none') {
            styles.push('list-style-type:' + listType);
          }
        }

        // Keep the source's own style (Google Docs / Word inline values).
        // Only fill gaps so mail still has font/size/color when the source
        // used a class or parent. Never overwrite what was copied.
        const sourceStyle = cloneElement.getAttribute('style') || '';
        if (styles.length > 0 || sourceStyle) {
          cloneElement.setAttribute('style', this.mergeCssDeclarations(sourceStyle, styles.join(';')));
        } else {
          cloneElement.removeAttribute('style');
        }

        // CSS classes like xl65/xl67 are no longer needed after styles are inlined.
        cloneElement.removeAttribute('class');

        // Remove editor-only attributes if any are present.
        cloneElement.removeAttribute('data-jodit-temp');
        cloneElement.removeAttribute('data-jodit-selection_marker');
      }
    } finally {
      if (probe && probe.parentNode) {
        probe.parentNode.removeChild(probe);
      }
    }

    this.mergeConsecutiveOrderedLists(clone);

    const innerHtml = this.sanitizeEcrHtml(clone.innerHTML);
    // Fallback only. Each content node already has its own font/size/color so
    // Outlook/Gmail cannot collapse Word/Excel formatting to this default.
    return '<div style="font-family:Arial, Helvetica, sans-serif;font-size:10pt;line-height:1.45;color:#0f172a">'
      + innerHtml
      + '</div>';
  }

  /**
   * Google Docs pastes each numbered item as its own <ol start="N"><li>...</li></ol>.
   * The editor still shows 1, 2, 3 because of start. Mail (and sanitize) often
   * drops start, so every item becomes 1. Word uses one <ol> with many <li>, so
   * it already survives. Merge sibling ordered lists before sending mail.
   */
  private mergeConsecutiveOrderedLists(root: HTMLElement): void {
    if (!root) {
      return;
    }

    Array.from(root.children).forEach(child => {
      this.mergeConsecutiveOrderedLists(child as HTMLElement);
    });

    let current = root.firstElementChild as HTMLElement | null;
    while (current) {
      if (current.tagName !== 'OL') {
        current = current.nextElementSibling as HTMLElement | null;
        continue;
      }

      let cursor = current.nextElementSibling as HTMLElement | null;
      const skipped: HTMLElement[] = [];
      while (cursor) {
        if (this.isEmptyListSeparator(cursor)) {
          skipped.push(cursor);
          cursor = cursor.nextElementSibling as HTMLElement | null;
          continue;
        }
        if (cursor.tagName === 'OL' && this.isSameOrderedListKind(current, cursor)) {
          const nextStart = parseInt(cursor.getAttribute('start') || '0', 10);
          const nextItem = cursor.querySelector('li');
          const nextValue = nextItem ? parseInt(nextItem.getAttribute('value') || '0', 10) : 0;
          // A blank line plus another list that also starts at 1 is a new list.
          // Google Docs continuations use start=2,3,... (or li value) even when a gap is present.
          if (skipped.length && nextStart <= 1 && nextValue <= 1) {
            break;
          }
          skipped.forEach(node => node.parentNode && node.parentNode.removeChild(node));
          skipped.length = 0;
          this.appendOrderedListItems(current, cursor);
          const remove = cursor;
          cursor = cursor.nextElementSibling as HTMLElement | null;
          if (remove.parentNode) {
            remove.parentNode.removeChild(remove);
          }
          continue;
        }
        break;
      }
      current = current.nextElementSibling as HTMLElement | null;
    }
  }

  private isEmptyListSeparator(element: HTMLElement): boolean {
    if (!element) {
      return false;
    }
    if (element.tagName === 'BR') {
      return true;
    }
    if (element.tagName !== 'P' && element.tagName !== 'DIV') {
      return false;
    }
    if (element.querySelector('img,table,ul,ol,hr')) {
      return false;
    }
    return !(element.textContent || '').replace(/\u00a0/g, ' ').trim();
  }

  private isSameOrderedListKind(left: HTMLElement, right: HTMLElement): boolean {
    const leftType = (left.getAttribute('type') || '').toLowerCase();
    const rightType = (right.getAttribute('type') || '').toLowerCase();
    if (leftType && rightType && leftType !== rightType) {
      return false;
    }
    const leftStyle = this.readInlineCss(left, 'list-style-type').toLowerCase();
    const rightStyle = this.readInlineCss(right, 'list-style-type').toLowerCase();
    if (leftStyle && rightStyle && leftStyle !== rightStyle) {
      return false;
    }
    return true;
  }

  private appendOrderedListItems(target: HTMLElement, source: HTMLElement): void {
    const firstItem = Array.from(source.children).find(child => child.tagName === 'LI') as HTMLElement;
    const sourceMarginTop = source.style.marginTop || this.readInlineCss(source, 'margin-top');
    if (firstItem && sourceMarginTop && sourceMarginTop !== '0px' && sourceMarginTop !== '0') {
      const existing = firstItem.getAttribute('style') || '';
      firstItem.setAttribute('style', this.mergeCssDeclarations(existing, 'margin-top:' + sourceMarginTop));
    }
    while (source.firstChild) {
      target.appendChild(source.firstChild);
    }
  }

  private createEcrStyleProbe(): HTMLElement {
    const probe = document.createElement('div');
    probe.setAttribute('data-ecr-style-probe', 'true');
    probe.style.cssText = [
      'position:absolute',
      'left:-99999px',
      'top:0',
      'visibility:hidden',
      'pointer-events:none',
      'font-family:Arial, Helvetica, sans-serif',
      'font-size:13px',
      'line-height:1.45',
      'color:#0f172a',
      'background-color:transparent'
    ].join(';');
    document.body.appendChild(probe);
    return probe;
  }

  private createEcrStyleProbeSample(probe: HTMLElement, tag: string): HTMLElement {
    const sample = document.createElement(tag);
    if (tag === 'td' || tag === 'th' || tag === 'tr') {
      const table = document.createElement('table');
      const tbody = document.createElement('tbody');
      const tr = tag === 'tr' ? sample as HTMLTableRowElement : document.createElement('tr');
      if (tag === 'td' || tag === 'th') {
        tr.appendChild(sample);
      }
      tbody.appendChild(tr);
      table.appendChild(tbody);
      probe.appendChild(table);
      return sample;
    }
    if (tag === 'li') {
      const list = document.createElement('ul');
      list.appendChild(sample);
      probe.appendChild(list);
      return sample;
    }
    probe.appendChild(sample);
    return sample;
  }

  private cssValuesEqual(left: string, right: string): boolean {
    const a = this.normalizeCssValue(left);
    const b = this.normalizeCssValue(right);
    if (a === b) {
      return true;
    }
    if (!a || !b) {
      return !a && !b;
    }
    if (this.isTransparentColor(a) && this.isTransparentColor(b)) {
      return true;
    }
    const pxA = this.parseCssPx(a);
    const pxB = this.parseCssPx(b);
    if (pxA !== null && pxB !== null && Math.abs(pxA - pxB) < 0.05) {
      return true;
    }
    return false;
  }

  private normalizeCssValue(value: string): string {
    return (value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  private isTransparentColor(value: string): boolean {
    const v = this.normalizeCssValue(value);
    return v === 'transparent' || v === 'rgba(0, 0, 0, 0)' || v === 'rgba(0,0,0,0)';
  }

  private parseCssPx(value: string): number | null {
    if (!value || value.length < 3 || value.slice(-2) !== 'px') {
      return null;
    }
    const parsed = parseFloat(value.slice(0, -2));
    return isNaN(parsed) ? null : parsed;
  }

  private preparePastedEcrHtml(html: string): string {
    return this.sanitizeEcrHtml(
      this.removeGoogleDocsImagePlaceholders(
        this.unwrapGoogleDocsPasteWrapper(this.inlinePastedOfficeStyles(html))
      )
    );
  }

  /**
   * Google Docs / Word often leave Object Replacement (U+FFFC) or a lone "?" where an
   * inline image sat. Those survive as visible "?" in mail when the image is dropped.
   */
  private removeGoogleDocsImagePlaceholders(html: string): string {
    if (!html) {
      return '';
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(String(html), 'text/html');

    const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
    const textNodes: Text[] = [];
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode as Text);
    }
    textNodes.forEach(node => {
      const original = node.nodeValue || '';
      const cleaned = original
        .replace(/\uFFFC/g, '')
        .replace(/\uFFFD/g, '')
        .replace(/[\u200B\u200C\u200D\uFEFF]/g, '');
      if (cleaned !== original) {
        node.nodeValue = cleaned;
      }
    });

    Array.from(doc.body.querySelectorAll('img')).forEach(img => {
      const alt = (img.getAttribute('alt') || '').trim();
      if (alt === '?' || alt === '\uFFFC' || alt === '\uFFFD') {
        img.setAttribute('alt', '');
      }
    });

    // Lone "?" blocks are Docs image placeholders, not real questions.
    Array.from(doc.body.querySelectorAll('p,div,span,h1,h2,h3,h4,h5,h6,li')).forEach(el => {
      if (el.querySelector('img,table,ul,ol,hr,iframe')) {
        return;
      }
      const text = (el.textContent || '').replace(/\u00a0/g, ' ').trim();
      if (text === '?') {
        el.remove();
      }
    });

    return doc.body.innerHTML;
  }

  /**
   * Desktop Word/Excel paste HTML as classes + a style block (MsoNormal, xl65).
   * Google Docs already inlines font/size/color. Copy Office stylesheet rules onto
   * matching elements before the style tag is stripped, so mail can keep the look.
   */
  private inlinePastedOfficeStyles(html: string): string {
    if (!html || (html.indexOf('<style') === -1 && html.indexOf('<STYLE') === -1)) {
      return html;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(String(html), 'text/html');
    const cssText = Array.from(doc.querySelectorAll('style'))
      .map(styleEl => styleEl.textContent || '')
      .join('\n')
      .replace(/<!--[\s\S]*?-->/g, match => match.replace(/<!--|-->/g, ''));

    this.parseSimpleCssRules(cssText).forEach(rule => {
      try {
        const nodes = doc.querySelectorAll(rule.selector);
        Array.from(nodes).forEach(node => {
          const el = node as HTMLElement;
          if (!el || !el.getAttribute) {
            return;
          }
          const merged = this.mergeCssDeclarations(el.getAttribute('style') || '', rule.declarations);
          if (merged) {
            el.setAttribute('style', merged);
          }
        });
      } catch (e) {
        // Skip Word selectors the browser cannot query (@page, mso conditionals).
      }
    });

    return doc.body.innerHTML;
  }

  /**
   * Google Docs wraps clipboard HTML in <b style="font-weight:normal" id="docs-internal-guid-...">.
   * If that wrapper is left as <b> without font-weight:normal, every nested font looks bold.
   */
  private unwrapGoogleDocsPasteWrapper(html: string): string {
    if (!html || html.indexOf('docs-internal-guid') === -1) {
      return html;
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(String(html), 'text/html');
    Array.from(doc.querySelectorAll('b[id^="docs-internal-guid"], strong[id^="docs-internal-guid"]')).forEach(wrapper => {
      const span = doc.createElement('span');
      const style = wrapper.getAttribute('style') || '';
      if (style) {
        span.setAttribute('style', style);
      }
      while (wrapper.firstChild) {
        span.appendChild(wrapper.firstChild);
      }
      if (wrapper.parentNode) {
        wrapper.parentNode.replaceChild(span, wrapper);
      }
    });
    return doc.body.innerHTML;
  }

  private parseSimpleCssRules(cssText: string): Array<{ selector: string; declarations: string }> {
    const rules: Array<{ selector: string; declarations: string }> = [];
    String(cssText || '').split('}').forEach(chunk => {
      const parts = chunk.split('{');
      if (parts.length < 2) {
        return;
      }
      const selectorBlock = parts[0].replace(/\/\*[\s\S]*?\*\//g, '').trim();
      const declarations = parts.slice(1).join('{').trim();
      if (!selectorBlock || selectorBlock.charAt(0) === '@' || !declarations) {
        return;
      }
      selectorBlock.split(',').forEach(rawSelector => {
        const selector = rawSelector.trim();
        if (!selector || selector.indexOf('@') !== -1 || selector.indexOf(':') !== -1) {
          return;
        }
        // Only class/id rules (p.MsoNormal, .xl65). Bare tags like b/span/p
        // would restyle Google Docs paste and force everything bold.
        if (selector.indexOf('.') === -1 && selector.indexOf('#') === -1) {
          return;
        }
        rules.push({ selector, declarations });
      });
    });
    return rules;
  }

  private mergeCssDeclarations(existing: string, incoming: string): string {
    const map: { [key: string]: string } = {};
    const apply = (block: string, overwrite: boolean) => {
      String(block || '').split(';').forEach(rule => {
        const idx = rule.indexOf(':');
        if (idx === -1) {
          return;
        }
        const name = rule.slice(0, idx).trim().toLowerCase();
        const value = rule.slice(idx + 1).trim();
        if (!name || !value || name.indexOf('mso-') === 0) {
          return;
        }
        if (overwrite || !map[name]) {
          map[name] = value;
        }
      });
    };
    apply(incoming, true);
    apply(existing, true);
    return Object.keys(map).map(name => name + ':' + map[name]).join(';');
  }

  private formatEmailCssProperty(property: string, computed: CSSStyleDeclaration, element: HTMLElement): string {
    if (property === 'font-size') {
      return this.formatEmailFontSize(computed, element);
    }
    if (property === 'color') {
      return this.toEmailColor(computed.getPropertyValue('color'));
    }
    if (property === 'font-weight') {
      return this.toEmailFontWeight(
        (element.style && element.style.fontWeight) ||
        this.readInlineCss(element, 'font-weight') ||
        computed.getPropertyValue('font-weight')
      );
    }
    if (property === 'font-style') {
      const specified = (element.style && element.style.fontStyle) ||
        this.readInlineCss(element, 'font-style') ||
        computed.getPropertyValue('font-style');
      return (specified || '').trim();
    }
    if (property === 'font-family') {
      const specified = (element.style && element.style.fontFamily) || this.readInlineCss(element, 'font-family');
      return this.normalizeFontFamilyForEmail(specified || computed.getPropertyValue('font-family'));
    }
    return (computed.getPropertyValue(property) || '').trim();
  }

  private formatEmailFontSize(computed: CSSStyleDeclaration, element: HTMLElement): string {
    const specified = (element.style && element.style.fontSize) || this.readInlineCss(element, 'font-size');
    if (specified) {
      const trimmed = specified.trim();
      if (/pt$/i.test(trimmed)) {
        return trimmed;
      }
      const specifiedPx = this.parseCssPx(trimmed);
      if (specifiedPx !== null) {
        return this.pxToPt(specifiedPx);
      }
      return trimmed;
    }
    const computedPx = this.parseCssPx(computed.getPropertyValue('font-size'));
    if (computedPx !== null) {
      return this.pxToPt(computedPx);
    }
    return (computed.getPropertyValue('font-size') || '').trim();
  }

  private pxToPt(px: number): string {
    const pt = Math.round((px * 72 / 96) * 100) / 100;
    return pt + 'pt';
  }

  private toEmailFontWeight(value: string): string {
    const v = (value || '').trim().toLowerCase();
    if (!v) {
      return 'normal';
    }
    const numeric = parseInt(v, 10);
    if (!isNaN(numeric)) {
      return numeric >= 600 ? 'bold' : 'normal';
    }
    if (v === 'bold' || v === 'bolder') {
      return 'bold';
    }
    return 'normal';
  }

  private toEmailColor(value: string): string {
    const v = (value || '').trim();
    if (!v || this.isTransparentColor(v)) {
      return '';
    }
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v)) {
      return v;
    }
    const rgb = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i.exec(v);
    if (rgb) {
      const hex = (n: string) => ('0' + Number(n).toString(16)).slice(-2);
      return '#' + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    if (/^black$/i.test(v)) {
      return '#000000';
    }
    if (/^white$/i.test(v)) {
      return '#ffffff';
    }
    return v;
  }

  private normalizeFontFamilyForEmail(value: string): string {
    return (value || '').trim() || 'Arial, Helvetica, sans-serif';
  }

  private readInlineCss(element: HTMLElement, property: string): string {
    const style = element.getAttribute('style') || '';
    const parts = style.split(';');
    for (let i = 0; i < parts.length; i++) {
      const idx = parts[i].indexOf(':');
      if (idx === -1) {
        continue;
      }
      if (parts[i].slice(0, idx).trim().toLowerCase() === property) {
        return parts[i].slice(idx + 1).trim();
      }
    }
    return '';
  }

  private sanitizeEcrHtml(value: string): string {
    if (!value) {
      return '';
    }

    const parser = new DOMParser();
    const documentFragment = parser.parseFromString(String(value), 'text/html');
    const allowedTags = /^(P|DIV|SPAN|STRONG|B|EM|I|U|S|SUP|SUB|BR|HR|UL|OL|LI|TABLE|THEAD|TBODY|TFOOT|TR|TD|TH|A|H1|H2|H3|H4|H5|H6|PRE|CODE|IMG|FONT)$/;
    const allowedAttributes = /^(class|style|title|align|colspan|rowspan|width|height|border|cellpadding|cellspacing|href|target|rel|src|alt|face|size|start|type|value)$/i;
    const safeCss = /^(color|background-color|font-family|font-size|font-weight|font-style|text-decoration|text-align|vertical-align|line-height|list-style(?:-type|-position|-image)?|margin(?:-(?:top|right|bottom|left))?|padding(?:-(?:top|right|bottom|left))?|border(?:-(?:top|right|bottom|left)(?:-(?:width|style|color))?)?|border-collapse|white-space|width|height)\s*:/i;

    const clean = (element: Element): void => {
      Array.from(element.children).forEach(child => {
        const htmlChild = child as HTMLElement;
        if (!allowedTags.test(htmlChild.tagName)) {
          if (/^(SCRIPT|STYLE|IFRAME|OBJECT|EMBED|FORM|BASE|META|LINK)$/i.test(htmlChild.tagName)) {
            htmlChild.remove();
            return;
          }
          while (htmlChild.firstChild) {
            element.insertBefore(htmlChild.firstChild, htmlChild);
          }
          element.removeChild(htmlChild);
          return;
        }

        Array.from(htmlChild.attributes).forEach(attribute => {
          const name = attribute.name.toLowerCase();
          const attrValue = attribute.value.trim();
          if (!allowedAttributes.test(name) || name.indexOf('on') === 0) {
            htmlChild.removeAttribute(attribute.name);
          } else if (name === 'href' || name === 'src') {
            // Keep public http(s), relative, anchors, mailto, and interim data:image
            // (pasted Docs images). Submit re-hosts data:/blob: before mail is built.
            const isSafeSrc = /^(https?:|mailto:|\/|#|data:image\/)/i.test(attrValue)
              || /^\/\/[\w.-]+/i.test(attrValue);
            if (!isSafeSrc || /^javascript:/i.test(attrValue) || /^data:(?!image\/)/i.test(attrValue)) {
              htmlChild.removeAttribute(attribute.name);
            } else if (name === 'src' && attrValue.indexOf('//') === 0) {
              htmlChild.setAttribute('src', 'https:' + attrValue);
            }
          } else if (name === 'style') {
            const styles = attrValue.split(';').map(rule => rule.trim()).filter(rule =>
              rule && safeCss.test(rule) && !/(expression|url\s*\(|javascript)/i.test(rule)
            );
            if (styles.length) {
              htmlChild.setAttribute('style', styles.join(';'));
            } else {
              htmlChild.removeAttribute('style');
            }
          }
        });

        if (htmlChild.tagName === 'IMG' && !htmlChild.getAttribute('src')) {
          htmlChild.remove();
          return;
        }
        clean(htmlChild);
      });
    };

    Array.from(documentFragment.body.children).forEach(element => clean(element));
    return this.removeGoogleDocsImagePlaceholders(documentFragment.body.innerHTML);
  }

  private hasMeaningfulEcrContent(): boolean {
    return this.isMeaningfulEcrHtml(this.EcrModel.ECRDetails || '');
  }

  private isMeaningfulEcrHtml(value: string): boolean {
    const html = this.sanitizeEcrHtml(value || '');
    const content = document.createElement('div');
    content.innerHTML = html;
    if (content.querySelector('img,table,hr,iframe,video,object')) {
      return true;
    }
    return !!(content.textContent || '').replace(/\u00a0/g, ' ').trim();
  }

  private getCcSearchInput(): HTMLInputElement | null {
    const root = this.ccWrap && this.ccWrap.nativeElement
      ? this.ccWrap.nativeElement
      : document;
    return root.querySelector('.filter-textbox input') as HTMLInputElement;
  }

  private keepCcDropdownOpenAndFocusSearch(): void {
    if (this.ccDropdown && this.ccDropdown._settings) {
      this.ccDropdown._settings.defaultOpen = true;
    }
    this.cdr.detectChanges();
    setTimeout(() => {
      if (this.ccDropdown && this.ccDropdown._settings) {
        this.ccDropdown._settings.defaultOpen = true;
      }
      const input = this.getCcSearchInput();
      if (input) {
        input.focus();
      }
      this.cdr.detectChanges();
    }, 0);
  }

  private clearCcSearchInput(focusSearch: boolean = true): void {
    if (this.ccFilterDebounceTimer) {
      clearTimeout(this.ccFilterDebounceTimer);
      this.ccFilterDebounceTimer = null;
    }
    if (this.ccFilterSearchSub) {
      this.ccFilterSearchSub.unsubscribe();
      this.ccFilterSearchSub = null;
    }

    this.ccSearchQuery = '';
    this.ccShowNoResults = false;
    this.updateCcDropdownPlaceholder(false, false);

    if (this.ccDropdown) {
      if (this.ccDropdown.filter) {
        this.ccDropdown.filter.text = '';
      }
      if (this.ccDropdown._settings) {
        this.ccDropdown._settings.defaultOpen = true;
      }
    }

    const input = this.getCcSearchInput();
    if (input) {
      input.value = '';
    }

    this.syncCcItemList();

    if (focusSearch) {
      this.keepCcDropdownOpenAndFocusSearch();
    } else {
      this.cdr.detectChanges();
    }
  }

  public onDropDownClose(item: any) {
    const target = this.ccPointerDownTarget;
    const clickedInsideList = !!(target && typeof target.closest === 'function' &&
      target.closest('.ecr-cc-wrap .dropdown-list'));

    if (this.ccKeepOpen || clickedInsideList) {
      this.keepCcDropdownOpenAndFocusSearch();
      return;
    }

    this.ccShowNoResults = false;
    this.ccSearchQuery = '';
    if (this.ccDropdown && this.ccDropdown.filter) {
      this.ccDropdown.filter.text = '';
    }
    this.syncCcItemList();
    this.cdr.detectChanges();
  }

  public onDeSelect(item: any) {
  }

  private ensureCcItemInList(item: any): void {
    if (!item || !item.id) {
      return;
    }
    const normalized = {
      id: item.id,
      item_text: item.item_text || item.id
    };
    const exists = this.itemList.some(entry => entry.id === normalized.id);
    if (!exists) {
      this.itemList = this.findUnique(this.itemList.concat([normalized]), d => d.id);
      this.cdr.detectChanges();
    }
  }


  SendingData(item) {
    item[2].append('TMCNo', this.EcrModel.TMCNo);
    item[2].append('Ecrdate', this.EcrModel.EcrDate);
  }


  // GetAllFiles(){   
  //  console.log(this.componentRef);
  //  this.GetAllFilesByEcrDate();

  // }
  // ValidateForm(item){
  //   
  //   alert('ECR Date');
  //   return;

  // }
  onRemovedFile(item: any) {
    if (this.suppressAttachmentDelete) {
      return;
    }
    const fileName = item && item.name;
    if (!fileName) {
      return;
    }
    this.DeleteECRFile(fileName);
  }

  onUploadSuccess(item: any) {
    console.log(item);
    console.log('File uploaded');
  }

  DeleteDefaultItem(id: any) {
    if (confirm('Do you want to remove  ' + id + ' from Default List')) {
      var indx = this.selectedDefaultList.findIndex(x => x.id == id);
      if (indx > -1) {
        this.selectedDefaultList.splice(indx, 1);
      }
    }

  }
  DeleteFavItem(id: any) {
    if (confirm('Do you want to remove ' + id + ' from Favorite List')) {

      var indx = this.selectedFavList.findIndex(x => x.id == id);
      if (indx > -1) {
        this.selectedFavList.splice(indx, 1);
      }
    }

  }


  ResetPopupData() {
    this.GetEmployees();
  }

  openEmailPanel(): void {
    this.GetPopupData();
    this.showEmailPanel = true;
    document.body.classList.add('ecr-email-drawer-open');
  }

  closeEmailPanel(): void {
    this.showEmailPanel = false;
    this.ResetPopupData();
    document.body.classList.remove('ecr-email-drawer-open');
  }

  GetPopupData() {
    // reserved for future preload hooks
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.showEmailPanel) {
      this.closeEmailPanel();
    }
  }
  ngAfterContentChecked() {
  }


  // getEmployee(TmcNo: string) {
  //   if (TmcNo != '' && TmcNo != undefined) {
  //     this._ecrService.GetReportingHeadDetails(TmcNo).subscribe(
  //       data => {
  //         if (data.Status) {
  //           this.EmployeeDetails = data.Data;
  //           this.EcrModel.ToEmail = data.Data.Company_E_Mail;
  //         }
  //         // else {
  //         //   this.getReportingHead(this.EcrModel.TMCNo);
  //         // }
  //       },
  //       error => {
  //         console.log(error);
  //         this._router.navigate(['/']);
  //       }
  //     );

  //   }
  //   else {
  //     this._router.navigate(['/']);
  //     this.sharedService.SwalErrorMsg('Something went wrong!');
  //   }
  // }

  // getReportingHead(Reporting_Head_ID) {
  //   this._crudService.get(`ecr/GetReportingHeadTHR?TmcNo=` + Reporting_Head_ID).subscribe((res: any) => {
  //     if (res.Status) {
  //       this.EcrModel.ToEmail = res.Data[0].THR_REPORTING_MANAGER_EMAIL_ID;
  //     }
  //   })
  // }

  SaveFavAndDefault() {
    this.SaveFavEmails();

  }
  SaveFavEmails() {
    var Favemails = "";
    var Defaultemails = "";
    //  if (Flag == 1) {
    this.selectedFavList.forEach((element, index) => {
      if (index === (this.selectedFavList.length - 1)) {
        Favemails += element.id;
      }
      else {
        Favemails += element.id + ",";
      }
    });
    //  }

    // else if (Flag == 2) {
    this.selectedDefaultList.forEach((element, index) => {
      if (index === (this.selectedDefaultList.length - 1)) {
        // This is the last one.
        Defaultemails += element.id;

      }
      else {
        Defaultemails += element.id + ",";
      }

    });
    //}

    this._ecrService.SaveFEmailSetting(this.EcrModel.TMCNo, Favemails, Defaultemails).subscribe(
      d => {
        console.log(d.Data);
        if (d.Status) {
          this.InitFunction();
          alert('Record saved successfully');
          this.closeEmailPanel();
        }
        else {
          alert(d.Message);
        }
      },
      e => { console.log(e); }
    );
  }

  GetEmailSettings() {
    this._ecrService.GetEmailSettings(this.EcrModel.TMCNo).subscribe(
      d => {
        // console.log(d.Data);
        if (d.Status) {
          this.selectedFavList = [];
          this.selectedDefaultList = [];
          if (d.Data != null) {
            if (d.Data.FavoriteEmailID != null) {

              d.Data.FavoriteEmailID.split(",").forEach(element => {
                if (element != "") {
                  this.selectedFavList.push({ "id": element, "name": element });
                }
              });
            }

          }

          var selectedVal = [];
          if (d.Data != null) {
            if (d.Data.DefaultEmailID != null) {
              d.Data.DefaultEmailID.split(",").forEach(element => {
                if (element != "") {
                  this.selectedDefaultList.push({ "id": element, "name": element });
                  selectedVal.push({ "id": element, "item_text": element });
                }
              });
            }

          }

          this.EcrModel.OtherEmail = selectedVal;
          console.log(this.EcrModel.OtherEmail);
          this.syncCcItemList();
          this.EcrModel.OtherEmail = selectedVal.slice();
          this.promptForSavedEcrDraft();

        }
        else {
          alert(d.Message);
          this.promptForSavedEcrDraft();
        }
      },
      e => {
        console.log(e);
        this.promptForSavedEcrDraft();
      }
    );


  }
  CloseDefaultList(item) {
    var divItem = (<HTMLInputElement>document.querySelector("#txtDefault input"));
    divItem.value = "";


    // var txt = document.getElementsByClassName("ng-pristine");
    // for(let i =0;i<txt.length;i++)
    // {
    // (<HTMLInputElement>txt[i]).value="";
    // }
    //  divItem.setAttribute("style", "color:#337ab7 !important;");

    //  this.FavEmailData="";
    //input.value = '';
    // alert('Hello');
  }
  selectDefaultList(item, input) {
    this.selectedDefaultList.unshift(item);
    this.selectedDefaultList = this.findUnique(this.selectedDefaultList, d => d.id);
    input.query = "";
  }

  findUnique(arr, predicate) {
    var found = {};
    arr.forEach(d => {
      found[predicate(d)] = d;
    });
    return Object.keys(found).map(key => found[key]);
  }

  selectFavList(item, input) {
    this.selectedFavList.unshift(item);
    this.selectedFavList = this.findUnique(this.selectedFavList, d => d.id);
    input.query = "";
  }

  onChangedSearchFav(item) {
    if (item && item.length >= 2) {
      this._ecrService.GetEmployeesListBySearch(item).subscribe(
        r => {
          if (r.Status) {
            let tempList = [];

            r.Data.forEach(element => {
              if (element != "") {
                tempList.push({
                  id: element.CompaneyEmail,
                  name: element.MemberName.toString().trim() + ' (' + element.CompaneyEmail + ')'
                });
              }
            });

            this.itemListAutoCom = this.findUnique(tempList, d => d.id);
          }
        },
        error => {
          console.error(error);
        }
      );
    } else {
      let tempList = [];
      if (this.employeesList) {
        this.employeesList.forEach(element => {
          if (element != "") {
            tempList.push({
              id: element.CompaneyEmail,
              name: element.MemberName.toString().trim() + ' (' + element.CompaneyEmail + ')'
            });
          }
        });
      }
      this.itemListAutoCom = this.findUnique(tempList, d => d.id);
    }
  }

  onChangedSearchDefault(item) {
    if (item && item.length >= 2) {
      this._ecrService.GetEmployeesListBySearch(item).subscribe(
        r => {
          if (r.Status) {
            let tempList = [];

            r.Data.forEach(element => {
              if (element != "") {
                tempList.push({
                  id: element.CompaneyEmail,
                  name: element.MemberName.toString().trim() + ' (' + element.CompaneyEmail + ')'
                });
              }
            });

            this.itemListDefaultAutoCom = this.findUnique(tempList, d => d.id);
          }
        },
        error => {
          console.error(error);
        }
      );
    } else {
      let tempList = [];
      if (this.employeesList) {
        this.employeesList.forEach(element => {
          if (element != "") {
            tempList.push({
              id: element.CompaneyEmail,
              name: element.MemberName.toString().trim() + ' (' + element.CompaneyEmail + ')'
            });
          }
        });
      }
      this.itemListDefaultAutoCom = this.findUnique(tempList, d => d.id);
    }
  }

  onFocused(e) {
    // do something when input is focused
  }
  valuelength: any = [];
  onItemSelect(item: any) {
    this.valuelength.push(item);
    this.ensureCcItemInList(item);
    this.ccKeepOpen = true;
    this.clearCcSearchInput(true);
    setTimeout(() => {
      this.ccKeepOpen = false;
    }, 400);
  }

  OnItemDeSelect(item: any) {
  }
  onSelectAll(items: any) {
  }
  onDeSelectAll(items: any) {
  }

  stringToDate(_date, _format, _delimiter) {
    var formatLowerCase = _format.toLowerCase();
    var formatItems = formatLowerCase.split(_delimiter);
    var dateItems = _date.split(_delimiter);
    var monthIndex = formatItems.indexOf("mm");
    var dayIndex = formatItems.indexOf("dd");
    var yearIndex = formatItems.indexOf("yyyy");
    var month = parseInt(dateItems[monthIndex]);
    month -= 1;
    var formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
    return formatedDate;
  }

  GetServerDate() {
    let promise = new Promise<any>((resolve, reject) => {
      this._ecrService.GeServerDate().toPromise()
        .then(r => {
          // console.log(r)      
          // Promise.resolve(r);
          resolve(r)

        })
        .catch(error => {
          Promise.reject(error);
        }
        );
    });
    return promise;
  }
  // GetEmailSetting() {
  //   let promise = new Promise<any>((resolve, reject) => {
  //     this._ecrService.GeServerDate().toPromise()
  //       .then(d => {console.log(d.Data);
  //         if (d.Status) {
  // this.selectedFavList=[];
  // this.selectedDefaultList=[];
  //           d.Data.FavoriteEmailID.split(",").forEach(element => {
  //             if (element != "") {
  //               this.selectedFavList.push({ "id": element, "name": element });
  //             }
  //           });
  //           var selectedVal = [];

  //           d.Data.DefaultEmailID.split(",").forEach(element => {
  //             if (element != "") {
  //               this.selectedDefaultList.push({ "id": element, "name": element });
  //               selectedVal.push({ "id": element, "item_text": element }); 
  //             }
  //           });
  //           this.EcrModel.OtherEmail = selectedVal;
  //           console.log(this.EcrModel.OtherEmail);
  //           resolve('Hello');          
  //         }
  //         else {
  //           alert(d.Message);
  //         }

  //       })
  //       .catch(error => {
  //         Promise.reject(error);
  //       }
  //       );
  //   });
  //   return promise;
  // }
  GetEmployees() {
    let promise = new Promise<any>((resolve, reject) => {
      this._ecrService.GetEmployees().toPromise()
        .then(r => {
          resolve(r)
          //  this.spinner.hide();

        })
        .catch(error => {
          Promise.reject(error);
        }
        );
    });
    return promise;
  }

  validationECRData() {
    var result = true;

    if (this.EcrModel.EcrDate == undefined || this.EcrModel.EcrDate == '' || this.EcrModel.EcrDate == null) {
      alert('Please select ECR Date');
      return result;
    }
    else if (!this.hasMeaningfulEcrContent()) {
      alert('Please fill ECR details');
      return result;
    }
    else if (this.EcrModel.ToEmail == undefined || this.EcrModel.ToEmail == '' || this.EcrModel.ToEmail == null) {
      alert('To Email is mandatory');
      return result;
    }
    else {
      result = false;
    }

    return result;
  }

  PostECRByTMC() {
    this.syncEcrEditorValue();
    this.EcrModel.TMCNo = sessionStorage.getItem('userId');
    this.EcrModel.EmployeeName = sessionStorage.getItem("FullName");
    this.EcrModel.FromEmail = sessionStorage.getItem("UserEmail");
    if (!this.ValidateEmail()) {
      return;
    }
    var str = "";
    if (this.EcrModel.OtherEmail && this.EcrModel.OtherEmail.length > 0) {
      this.EcrModel.OtherEmail.forEach(element => {
        if (element.item_text && element.item_text != 'undefined') {
          str += element.item_text + ",";
        }
      });
    }

    if (str == "" || str == "undefined,") {
      str = " ";
    }
    var ecrd = this.datepipe.transform(this.EcrModel.EcrDate, 'dd-MM-yyyy');
    if (!this.validationECRData()) {
      Swal.fire({
        title: 'You are going to submit ECR for : ' + ecrd + '.' + '<br/>' + 'Please review again and Click on "Confirm" for final submission.',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        allowOutsideClick: false,
        background: '#e0f0ff',
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.DisableSubmitButton = true;
          try {
            // Re-host pasted Docs/Word images before building email HTML.
            // Live editor may still show blob: view URLs that sanitize would drop.
            await this.enqueueEmbeddedImageUpload();
            this.scrubLiveEditorImagePlaceholders();
            // Drop unused inline paste uploads so text-only ECRs do not attach them.
            await this.cleanupUnreferencedInlineEcrImages();
          } catch (error) {
            console.error('ECR image prepare failed', error);
          }

          this.EcrModel.ECRStatus = "SUBMITTED";
          this.EcrModel.ECRSubject = "ECR -" + this.EcrModel.EcrDate;

          this.EcrModel.ECRDetails = this.getEcrHtmlForEmail();

          if (this.editorHasUnhostedImages()) {
            this.DisableSubmitButton = false;
            alert('Some pasted images could not be uploaded for email. Please re-insert them using the Image button or attachment upload, then submit again.');
            return;
          }

          console.log('FINAL ECR HTML GOING TO API:', this.EcrModel.ECRDetails);

          let formData: FormData = new FormData();
          formData.append("OtherEmail", JSON.stringify(str));
          formData.append("Ecrdate", this.EcrModel.EcrDate);
          formData.append("SubmittedDate", this.EcrModel.SubmittedDate);
          formData.append("Ecrsubject", this.EcrModel.ECRSubject);
          formData.append("Ecrdetails", this.EcrModel.ECRDetails);
          formData.append("Ecrid", "0");
          formData.append("Ecrstatus", this.EcrModel.ECRStatus);
          formData.append("Tmcno", this.EcrModel.TMCNo);
          formData.append("ToEmail", this.EcrModel.ToEmail);
          formData.append("UserFullName", this.EcrModel.EmployeeName);
          formData.append("UserEmail", this.EcrModel.FromEmail);
          formData.append("CompanyName", this.CompanyName);
          console.log('this.companyName>>', this.CompanyName);

          this._ecrService.PostECR(formData).subscribe(
            data => {
              if (data.Status) {
                if (data.Data.ECRId != undefined && data.Data.ECRId > 0) {
                  this.clearInlineEcrFileNamesForCurrentDate();
                  this.rememberSubmittedEcrDate(this.EcrModel.EcrDate);
                  this.clearSubmittedDayAttachments();
                  alert('ECR has been Successfully Submitted.');
                  this.resetEcrFormAfterSubmit();
                }
                else {
                  alert(data.Message);
                }
              }
              else {
                alert(data.Message);
              }
              this.DisableSubmitButton = false;
            },
            error => {
              if (error.statusText) {
                console.log(error);
                this.DisableSubmitButton = false;
              }
              console.log(error);
            }
          );

        }

      })
    }
  }
  selectCC() {
  }

  ValidateEmail() {
    var regularExpression = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    var valid = regularExpression.test(this.EcrModel.ToEmail) //match a letter _and_ a number
    if (!valid) {
      this.sharedService.SwalErrorMsg("Please enter valid Email Id");
      return false;
    }
    else {
      return true;
    }
  }

  ngOnDestroy(): void {
    if (this.jodit) {
      this.syncEcrEditorValue();
    }
    this.saveEcrDraft();
    if (this.ecrDraftSaveTimer) {
      clearTimeout(this.ecrDraftSaveTimer);
      this.ecrDraftSaveTimer = null;
    }
    if (this.jodit) {
      this.jodit.destruct();
      this.jodit = null;
    }
    if (this.ccFilterDebounceTimer) {
      clearTimeout(this.ccFilterDebounceTimer);
      this.ccFilterDebounceTimer = null;
    }
    if (this.ccFilterSearchSub) {
      this.ccFilterSearchSub.unsubscribe();
      this.ccFilterSearchSub = null;
    }
    document.body.classList.remove('ecr-email-drawer-open');
  }

}